/** 由 scripts/gen-locales.mjs 生成，请勿手改；文案请编辑 src/locales/source/ */
export default {
  "aiFeedback.conversation_id": "Conversation ID",
  "aiFeedback.created": "Submitted at",
  "aiFeedback.detail": "Details",
  "aiFeedback.kind": "Type",
  "aiFeedback.message_id": "Message ID",
  "aiFeedback.model": "Model",
  "aiFeedback.platform": "Platform",
  "aiFeedback.rating": "Rating",
  "aiFeedback.result_id": "Result ID",
  "aiFeedback.result_text": "Result",
  "aiFeedback.role": "Role",
  "aiFeedback.source_language": "Source language",
  "aiFeedback.source_text": "Source / transcript",
  "aiFeedback.suggestion": "Suggestion",
  "aiFeedback.target": "Target language",
  "aiFeedback.target_language": "Target language",
  "aiFeedback.title": "Translation and transcription feedback",
  "aiFeedback.transcription": "Transcription",
  "aiFeedback.translation": "Translation",
  "aiFeedback.user": "User",
  "Bot促活推送.保存成功": "Settings saved",
  "Bot促活推送.保存生效": "Save",
  "Bot促活推送.最低岗位数": "Minimum jobs",
  "Bot促活推送.刷新": "Refresh",
  "Bot促活推送.历史文案未保存": "Message content was not stored for this historical record.",
  "Bot促活推送.发送失败": "Failed",
  "Bot促活推送.发送成功": "Sent",
  "Bot促活推送.发送日期": "Delivery date",
  "Bot促活推送.发送时间": "Send time",
  "Bot促活推送.发送时间校验": "Choose a time from 08:00 to 21:59.",
  "Bot促活推送.发送结果": "Result",
  "Bot促活推送.发送计划": "Schedule and copy",
  "Bot促活推送.发送记录": "Delivery history",
  "Bot促活推送.取数说明": "No send below 10 jobs. Show 15+ for 10–19, 45+ for 20–49, 80+ for 50–99, and 100+ for 100 or more. Use continuous P80 of valid monthly salary midpoints; exclude negotiable, missing or invalid salaries. Display monthly salary $XX+.",
  "Bot促活推送.变量说明": "Body supports {count}, {position}, and {location}. Salary line supports {salary}.",
  "Bot促活推送.后台总开关": "Enable scheduled Bot activation",
  "Bot促活推送.启用": "Enable slot",
  "Bot促活推送.夜间免打扰说明": "Beijing time. No delivery from 22:00 to 08:00.",
  "Bot促活推送.失败原因": "Failure reason",
  "Bot促活推送.岗位取数规则": "Job data rules",
  "Bot促活推送.岗位数量": "Job count",
  "Bot促活推送.已点击": "Clicked {count} times",
  "Bot促活推送.总开关关闭": "The server kill switch is off in this environment. Settings can be saved, but scheduled messages will not send.",
  "Bot促活推送.打开试发": "Open Bot test",
  "Bot促活推送.接收用户": "Recipient",
  "Bot促活推送.数量展示": "Job count display",
  "Bot促活推送.数量展示.exact": "Exact count",
  "Bot促活推送.数量展示.range": "Count tiers (15+ / 45+ / 80+ / 100+)",
  "Bot促活推送.新增策略": "Add strategy",
  "Bot促活推送.新策略默认名称": "New activation strategy",
  "Bot促活推送.是否点击": "Clicked",
  "Bot促活推送.未点击": "No click",
  "Bot促活推送.未绑定用户": "No linked App user",
  "Bot促活推送.正文": "Bot body",
  "Bot促活推送.点击按钮": "Button",
  "Bot促活推送.点击记录": "Clicks",
  "Bot促活推送.策略.fallback": "No-profile channel prompt",
  "Bot促活推送.策略.generic_jobs": "Generic jobs without profile",
  "Bot促活推送.策略.jobs": "Profile-matched channel prompt",
  "Bot促活推送.策略.location_jobs": "Location match",
  "Bot促活推送.策略.matched_jobs": "Job type and location match",
  "Bot促活推送.策略.position_jobs": "Job type match",
  "Bot促活推送.策略名称": "Strategy name",
  "Bot促活推送.策略类型": "Audience type",
  "Bot促活推送.薪资取整": "Salary rounding",
  "Bot促活推送.薪资文案": "Salary line",
  "Bot促活推送.薪资文案说明": "Optional. Must include {salary}; appended only when salary is available.",
  "Bot促活推送.薪资算法": "Salary calculation",
  "Bot促活推送.薪资算法.none": "Do not calculate",
  "Bot促活推送.薪资算法.p80_midpoint": "P80 of job salary midpoints",
  "Bot促活推送.记录ID": "Record ID",
  "Bot促活推送.语言.en_US": "English",
  "Bot促活推送.语言.km_KH": "Khmer",
  "Bot促活推送.语言.zh_CN": "Chinese",
  "Bot促活推送.运行配置": "Runtime",
  "Bot促活推送.页面标题": "Bot activation push",
  "Bot促活推送.页面说明": "Manage scheduled activation for the job and resume contact Bot. Changes take effect within about 20 seconds. Times use Beijing time.",
  "Bot促活推送.频控说明": "Existing frequency caps remain: up to one app-return message per user per day and two per rolling seven days. Channel prompts use a seven-day interval, extended to 14 days after repeated ignores.",
  "menu.account": "Account",
  "menu.account.logout": "Logout",
  "menu.account.settings": "Settings",
  "menu.ad-channels": "Ad Channels",
  "menu.commercial": "Commercial",
  "menu.commercial.commercial-benefits": "Benefits",
  "menu.commercial.commercial-orders": "Orders",
  "menu.commercial.commercial-paywalls": "Paywalls",
  "menu.commercial.commercial-products": "Products",
  "menu.companies": "Companies",
  "menu.companies.companies-config": "Config",
  "menu.companies.companies-list": "Company List",
  "menu.config": "Config",
  "menu.config.benefit-guarantee-tags": "Tag lexicon",
  "menu.config.employer-sales-contacts": "Sales Contacts",
  "menu.config.hot-job-groups": "Hot Group Config",
  "menu.config.hot-search-words": "Hot Search Words",
  "menu.config.jd-complaint-types": "Complaint Types",
  "menu.config.jd-feedback-types": "Job Feedback Types",
  "menu.config.job-groups": "Job Group Config",
  "menu.config.job-positions": "Job Positions",
  "menu.config.job-relations": "Related Job Config",
  "menu.config.locations": "Locations",
  "menu.config.visitor-contact-limit": "Visitor Contact Limit",
  "menu.content": "Content",
  "menu.content.content-articles": "Articles",
  "menu.content.content-media-partners": "Media Partners",
  "menu.facebook": "Facebook Matrix",
  "menu.facebook.facebook-entities": "Data Sources",
  "menu.feedback": "Feedback",
  "menu.feedback.account-appeals-list": "Account Appeals",
  "menu.feedback.feedback-list": "Feedback List",
  "menu.feedback.im-presets": "IM quick phrases",
  "menu.feedback.jd-feedback-records-list": "Job Feedback Records",
  "menu.feedback.job-complaints-list": "Job Complaints",
  "menu.feedback.job-taxonomy-search-feedbacks": "Job Search Feedback",
  "menu.feedback.match-feedback": "IM match feedback",
  "menu.feedback.resume-complaints-list": "Resume Complaints",
  "menu.home": "Home",
  "menu.job-seekers": "Job Seekers",
  "menu.job-seekers.job-seekers-job-intention-detail": "Intention Detail",
  "menu.job-seekers.job-seekers-job-intentions": "Job Intentions",
  "menu.job-seekers.job-seekers-resume-detail": "Resume Detail",
  "menu.job-seekers.job-seekers-resume-source-files": "Resume File Review",
  "menu.job-seekers.job-seekers-resumes": "Resumes",
  "menu.job-seekers.job-seekers-user-detail": "User Detail",
  "menu.job-seekers.job-seekers-users": "Users",
  "menu.jobs": "Jobs",
  "menu.jobs.jobs-blacklist": "Job Blacklist",
  "menu.jobs.jobs-generation": "Generation",
  "menu.jobs.jobs-generation-dashboard": "Job Data Dashboard",
  "menu.jobs.jobs-list": "Job List",
  "menu.jobs.jobs-review-records": "Review Records",
  "menu.login": "Login",
  "menu.staff": "Staff",
  "menu.staff.staff-detail": "Staff Detail",
  "menu.staff.staff-list": "Staff List",
  "menu.staff.staff-operation-logs": "Operation Logs",
  "menu.staff.staff-roles-permissions": "Roles & Permissions",
  "menu.telegram": "Telegram",
  "menu.telegram.telegram-accounts": "Accounts",
  "menu.telegram.telegram-dashboard": "Dashboard",
  "menu.telegram.telegram-entities": "Entities",
  "menu.test": "Test",
  "menu.test.google-map": "Google Map Test",
  "menu.tools": "Operations Tools",
  "menu.tools.bot-activation-push": "Bot activation push",
  "menu.tools.facebook-reauth-push": "Facebook Push Test",
  "menu.tools.home-marquee-banners": "Home Marquee Banners",
  "menu.tools.home-shortcuts": "Home Shortcuts",
  "menu.tools.marketing-push": "Marketing push",
  "menu.tools.mobile-push": "Mobile Push Test",
  "menu.tools.telegram-push": "Bot Activation Test",
  "menu.welcome": "Welcome",
  "navBar.lang": "Language",
  "匹配反馈.ignored": "Ignored",
  "匹配反馈.pending": "Pending",
  "匹配反馈.processed": "Processed",
  "匹配反馈.会话": "Conversation",
  "匹配反馈.保存": "Save",
  "匹配反馈.候选人": "Candidate",
  "匹配反馈.允许补充说明": "Allow additional details",
  "匹配反馈.原因": "Reasons",
  "匹配反馈.原因配置": "Reason configuration",
  "匹配反馈.发起人": "Submitted by",
  "匹配反馈.否": "No",
  "匹配反馈.启用": "Enabled",
  "匹配反馈.处理状态": "Processing status",
  "匹配反馈.岗位": "Job",
  "匹配反馈.已保存": "Saved",
  "匹配反馈.已取消": "Cancelled",
  "匹配反馈.招聘者": "Recruiter",
  "匹配反馈.排序": "Order",
  "匹配反馈.操作": "Actions",
  "匹配反馈.新增": "Add",
  "匹配反馈.时间": "Time",
  "匹配反馈.是": "Yes",
  "匹配反馈.标题": "IM match feedback",
  "匹配反馈.求职者": "Job seeker",
  "匹配反馈.生效": "Active",
  "匹配反馈.编码": "Code",
  "匹配反馈.编辑": "Edit",
  "匹配反馈.补充说明": "Additional details",
  "匹配反馈.记录": "Records",
  "匹配反馈.详情": "Details",
  "匹配反馈.说明限制": "One details option per role, up to 500 characters. Disabling preserves history.",
  "匹配反馈.身份": "Role",
  "匹配反馈.运营备注": "Operator notes",
  "布局.用户.帮助": "Help",
  "布局.用户.条款": "Terms",
  "布局.用户.隐私": "Privacy",
  "布局.页脚.版权": "2026 dodojob Operations Admin Console",
  "常用语.availability": "Availability",
  "常用语.decline": "Polite decline",
  "常用语.first_contact": "First contact",
  "常用语.follow_up": "Follow-up",
  "常用语.interview": "Interview",
  "常用语.resume": "Resume",
  "常用语.保存发布": "Save and publish",
  "常用语.内容": "Content",
  "常用语.场景": "Scenario",
  "常用语.标题": "IM quick phrases",
  "常用语.长度限制": "Up to 200 characters",
  "应用.PWA.刷新": "Refresh",
  "应用.PWA.刷新提示": "Click refresh or reload the page",
  "应用.PWA.有新内容": "New content",
  "应用.PWA.离线": "You are offline",
  "组件.地区与字典.一级": "Level 1",
  "组件.地区与字典.三级": "Level 3",
  "组件.地区与字典.二级": "Level 2",
  "组件.地区与字典.地区不存在显示原始code": "Region not found, raw code: {code}",
  "组件.地区与字典.字典项不存在显示原始id": "Dictionary item not found, raw id: {id}",
  "组件.地区与字典.当前": "(current)",
  "组件.地区与字典.暂无多语言": "No translations",
  "组件.地区与字典.第N级": "Level {n}",
  "组件.地址.关闭": "Close",
  "组件.地址.加载地图中": "Loading map...",
  "组件.地址.在地图中查看地址": "View address on map",
  "组件.地址.在地图中编辑地址": "Edit address on map",
  "组件.地址.在地图中选择地址": "Select address on map",
  "组件.地址.地区": "Region",
  "组件.地址.地图显示": "Map",
  "组件.地址.地址预览": "Address preview",
  "组件.地址.地点已选择": "Place selected",
  "组件.地址.地点选择": "Place",
  "组件.地址.当前地址": "Current address: ",
  "组件.地址.搜索地址": "Search address",
  "组件.地址.未找到地址": "No matching address found",
  "组件.地址.未配置GoogleMapsAPIKey": "Google Maps API Key not set. Set GOOGLE_MAPS_API_KEY in env.",
  "组件.地址.标准地址": "Standard address: ",
  "组件.地址.生成地图图片": "Generate map image",
  "组件.地址.详细地址": "Detail address",
  "组件.地址.语言": "Language",
  "组件.地址.请先选择地点": "Select a place first",
  "组件.地址.请输入地点名称或地址": "Enter place name or address",
  "组件.地址.请输入详细地址如3楼301室": "e.g. Room 301, 3F",
  "组件.地址.预览图生成中": "Map preview is still uploading. Please submit later.",
  "组件.地址.预览图生成失败": "Failed to generate map preview. Select the place again and retry.",
  "组件.地址.预览图生成成功": "Map image generated",
  "组件.标签选择.全部": "All",
  "组件.标签选择.展开": "Expand",
  "组件.标签选择.收起": "Collapse",
  "组件.顶栏.使用文档": "Docs",
  "组件.顶栏.站内搜索": "Search",
  "组件.顶栏.通知": "Notifications",
  "菜单.Facebook矩阵": "Facebook Matrix",
  "菜单.Facebook矩阵.数据源配置": "Data Sources",
  "菜单.Telegram矩阵": "Telegram",
  "菜单.Telegram矩阵.Dashboard": "Dashboard",
  "菜单.Telegram矩阵.会话管理": "Entities",
  "菜单.Telegram矩阵.账号管理": "Accounts",
  "菜单.个人页": "Account",
  "菜单.个人页.个人设置": "Settings",
  "菜单.企业管理": "Companies",
  "菜单.企业管理.企业管理": "Company List",
  "菜单.企业管理.配置管理": "Config",
  "菜单.内容管理": "Content",
  "菜单.内容管理.合作媒体": "Media Partners",
  "菜单.内容管理.资讯发布": "Articles",
  "菜单.反馈与投诉": "Feedback",
  "菜单.反馈与投诉.岗位反馈记录": "Job Feedback Records",
  "菜单.反馈与投诉.岗位投诉列表": "Job Complaints",
  "菜单.反馈与投诉.工种搜索反馈": "Job Search Feedback",
  "菜单.反馈与投诉.意见反馈列表": "Feedback List",
  "菜单.反馈与投诉.简历投诉列表": "Resume Complaints",
  "菜单.反馈与投诉.账号申诉列表": "Account Appeals",
  "菜单.员工管理": "Staff",
  "菜单.员工管理.员工列表": "Staff List",
  "菜单.员工管理.员工详情": "Staff Detail",
  "菜单.员工管理.操作记录": "Operation Logs",
  "菜单.员工管理.角色和权限": "Roles & Permissions",
  "菜单.商业化管理": "Commercial",
  "菜单.商业化管理.商品管理": "Products",
  "菜单.商业化管理.权益配置": "Benefits",
  "菜单.商业化管理.订单管理": "Orders",
  "菜单.商业化管理.页面配置": "Paywalls",
  "菜单.岗位管理": "Jobs",
  "菜单.岗位管理.审核记录": "Review Records",
  "菜单.岗位管理.岗位生成": "Generation",
  "菜单.岗位管理.岗位生成数据看板": "Job Data Dashboard",
  "菜单.岗位管理.岗位管理": "Job List",
  "菜单.岗位管理.岗位黑名单": "Job Blacklist",
  "菜单.推广渠道管理": "Ad Channels",
  "菜单.欢迎": "Welcome",
  "菜单.求职用户": "Job Seekers",
  "菜单.求职用户.求职意向": "Job Intentions",
  "菜单.求职用户.求职意向详情": "Intention Detail",
  "菜单.求职用户.用户管理": "Users",
  "菜单.求职用户.用户详情": "User Detail",
  "菜单.求职用户.简历管理": "Resumes",
  "菜单.求职用户.简历详情": "Resume Detail",
  "菜单.求职用户.简历附件审核": "Resume File Review",
  "菜单.测试页面": "Test",
  "菜单.测试页面.Google地图测试": "Google Map Test",
  "菜单.登录": "Login",
  "菜单.运营工具": "Operations Tools",
  "菜单.运营工具.Bot促活推送": "Bot activation push",
  "菜单.运营工具.Bot促活测试": "Bot Activation Test",
  "菜单.运营工具.Facebook重新授权推送测试": "Facebook Push Test",
  "菜单.运营工具.移动推送测试": "Mobile Push Test",
  "菜单.运营工具.营销推送": "Marketing push",
  "菜单.运营工具.首页跑马灯": "Home Marquee Banners",
  "菜单.运营工具.首页金刚位": "Home Shortcuts",
  "菜单.退出登录": "Logout",
  "菜单.配置管理": "Config",
  "菜单.配置管理.关联工种配置": "Related Job Config",
  "菜单.配置管理.地区管理": "Locations",
  "菜单.配置管理.岗位分组配置": "Job Group Config",
  "菜单.配置管理.岗位反馈类型": "Job Feedback Types",
  "菜单.配置管理.岗位投诉类型": "Complaint Types",
  "菜单.配置管理.岗位标签": "Job Positions",
  "菜单.配置管理.游客联系限制": "Visitor Contact Limit",
  "菜单.配置管理.热搜词配置": "Hot Search Words",
  "菜单.配置管理.热门分组配置": "Hot Group Config",
  "菜单.配置管理.福利与保障标签": "Tag lexicon",
  "菜单.配置管理.销售联系方式": "Sales Contacts",
  "菜单.首页": "Home",
  "营销推送.Bot媒体": "Bot media",
  "营销推送.Bot按钮": "Bot button",
  "营销推送.Bot按钮文字": "Button label",
  "营销推送.Bot按钮类型": "Button type",
  "营销推送.Bot按钮类型.app_page": "Open App page",
  "营销推送.Bot按钮类型.channel": "Telegram channel",
  "营销推送.Bot按钮类型.mini_app": "Telegram Mini App",
  "营销推送.Bot按钮说明": "Add up to 3 buttons, one per row. Button labels follow the selected language.",
  "营销推送.Bot按钮链接": "Telegram link",
  "营销推送.Bot按钮页面": "App page",
  "营销推送.Bot正文": "Bot message",
  "营销推送.Bot消息类型": "Bot message type",
  "营销推送.Bot消息类型.image": "Image and text",
  "营销推送.Bot消息类型.text": "Text",
  "营销推送.Bot消息类型.video": "Video and text",
  "营销推送.broadcast": "General marketing",
  "营销推送.generic_jobs": "Jobs without a profile",
  "营销推送.location_jobs": "Jobs by location",
  "营销推送.matched_jobs": "Jobs by role and location",
  "营销推送.position_jobs": "Jobs by role",
  "营销推送.resume_incomplete": "Complete a resume",
  "营销推送.resume_missing": "Create a resume",
  "营销推送.下次发送": "Next scheduled time",
  "营销推送.人群": "Audience",
  "营销推送.仅限HTTPS": "Enter a complete HTTPS URL",
  "营销推送.保存为暂停": "Save paused",
  "营销推送.保存生效": "Save changes",
  "营销推送.全部用户": "All App users (signed-in and guests)",
  "营销推送.全部用户说明": "Targets signed-in users and guests with active push devices. Preview and test the message before enabling.",
  "营销推送.删除": "Remove",
  "营销推送.刷新": "Refresh",
  "营销推送.加载岗位失败": "Could not load jobs",
  "营销推送.区域": "Sample location",
  "营销推送.历史文案未保存": "Message content was not saved",
  "营销推送.历史记录": "Legacy record",
  "营销推送.历史记录说明": "Older records have no environment tag and are shown only in production.",
  "营销推送.参数.apply_job_id": "Application job ID (optional)",
  "营销推送.参数.benefit_tags": "Benefit tag codes (comma-separated)",
  "营销推送.参数.category_id": "Job category code",
  "营销推送.参数.company_id": "Company ID",
  "营销推送.参数.job_category_code": "Job role code (optional)",
  "营销推送.参数.job_id": "Job ID",
  "营销推送.参数.job_position_tags": "Job role codes (comma-separated)",
  "营销推送.参数.keyword": "Search keyword",
  "营销推送.参数.locations": "Location codes (comma-separated)",
  "营销推送.参数.source_job_id": "Source job ID (optional)",
  "营销推送.参数.title": "Page title (optional)",
  "营销推送.参数.url": "Web URL",
  "营销推送.发送失败": "Failed",
  "营销推送.发送成功": "Sent",
  "营销推送.发送日期": "Delivery dates",
  "营销推送.发送时间": "Send time (Beijing)",
  "营销推送.发送测试": "Send to test user",
  "营销推送.发送类型": "Delivery type",
  "营销推送.发送结果": "Result",
  "营销推送.发送记录": "Delivery history",
  "营销推送.发送记录说明": "Each row records one device delivery; retries update the same row. Sent means the push provider accepted it, not that the user viewed it.",
  "营销推送.变量说明": "Variables: '{count}', '{position}', '{location}', '{salary}'. Use only data available for this audience. Keep one salary-free template per language. Templates rotate by weekday.",
  "营销推送.后台试发": "Test send",
  "营销推送.启用": "Enabled",
  "营销推送.固定文案说明": "Broadcasts use fixed copy without personal job, location or salary variables.",
  "营销推送.处理中": "Processing",
  "营销推送.失败原因": "Failure reason",
  "营销推送.定时发送": "Scheduled",
  "营销推送.尝试次数": "Attempts",
  "营销推送.岗位数量": "Job count",
  "营销推送.工种": "Sample role",
  "营销推送.已保存": "Saved. Changes will take effect automatically.",
  "营销推送.已跳过": "Skipped",
  "营销推送.当前绑定": "Current device account",
  "营销推送.当前绑定说明": "Older records have no recipient snapshot. This is the current device account and may differ from the original recipient.",
  "营销推送.总开关关闭": "Automatic marketing push is off in this environment. You can save and test; scheduled messages will not send.",
  "营销推送.执行星期": "Weekdays",
  "营销推送.按原策略跳转": "Use campaign default",
  "营销推送.按现有策略": "Existing targeting rules",
  "营销推送.接收用户": "Recipient",
  "营销推送.搜索岗位": "Search job title or number",
  "营销推送.操作": "Actions",
  "营销推送.操作失败": "Action failed. Check the input; if the configuration changed, close and refresh before retrying.",
  "营销推送.新增说明": "Preview and send to a test account before saving. New plans are saved paused; enable them in the list to start scheduled delivery.",
  "营销推送.时间范围": "Choose 08:00–20:59",
  "营销推送.时间说明": "Beijing time, 08:00–20:59. Changes load within 30 seconds. Each plan runs at most once per day; missed times are not replayed.",
  "营销推送.星期0": "Mon",
  "营销推送.星期1": "Tue",
  "营销推送.星期2": "Wed",
  "营销推送.星期3": "Thu",
  "营销推送.星期4": "Fri",
  "营销推送.星期5": "Sat",
  "营销推送.星期6": "Sun",
  "营销推送.标题": "Title",
  "营销推送.模板": "Template",
  "营销推送.模板序号": "Template number",
  "营销推送.模板数量": "Templates",
  "营销推送.正文": "Body",
  "营销推送.测试账号": "Test user ID",
  "营销推送.添加Bot按钮": "Add Bot button",
  "营销推送.添加模板": "Add template",
  "营销推送.添加营销推送": "Add marketing push",
  "营销推送.游客": "Guest",
  "营销推送.登录用户": "App user",
  "营销推送.策略配置": "Plan settings",
  "营销推送.编辑": "Edit",
  "营销推送.联系Bot说明": "Tapping opens the job/resume contact Bot, not the login Bot. Each content change gets a new link; old pushes keep their original content.",
  "营销推送.落地页.company_homepage": "Company page",
  "营销推送.落地页.external_web": "External browser",
  "营销推送.落地页.internal_web": "In-app web page",
  "营销推送.落地页.job_category": "Job category",
  "营销推送.落地页.job_detail": "Job details",
  "营销推送.落地页.job_search": "Job search",
  "营销推送.落地页.jobs_home": "Jobs home",
  "营销推送.落地页.profile_home": "My profile",
  "营销推送.落地页.resume_card_form": "Resume form",
  "营销推送.落地页.resume_manage": "Manage resume",
  "营销推送.落地页.talent_pool_home": "Talent pool",
  "营销推送.落地页.telegram_contact_bot": "Bot push",
  "营销推送.薪资": "Monthly salary (USD)",
  "营销推送.计划": "Plan",
  "营销推送.计划列表": "Push plans",
  "营销推送.计划名称": "Plan name",
  "营销推送.记录ID": "Record ID",
  "营销推送.设备ID": "Device ID",
  "营销推送.设备平台": "Platform",
  "营销推送.试发结果": "Devices: {total}; accepted: {success}; failed: {failed}. Verify receipt on the test device.",
  "营销推送.语言": "Language",
  "营销推送.请上传Bot媒体": "Upload an image or video",
  "营销推送.跳转目标": "Destination",
  "营销推送.跳转说明": "Tapping the notification opens this page. Set its parameters after changing the destination.",
  "营销推送.身份未知": "Identity unavailable",
  "营销推送.选择工种": "Choose a job type",
  "营销推送.页面标题": "App marketing push",
  "营销推送.页面说明": "Configure App marketing templates, schedules and destinations.",
  "营销推送.预览": "Preview",
  "营销推送.预览与试发": "Preview and test",
  "营销推送.默认跳转说明": "Job recommendations open the jobs home with the user’s role; resume reminders open the resume form. Preview shows the default page.",
  "设置.基本信息.昵称": "Nickname",
  "设置.菜单.基本设置": "Basic",
  "设置抽屉.主题色": "Theme",
  "设置抽屉.整体风格": "Page style",
  "通用.上传中": "Uploading…",
  "通用.上传失败": "Upload failed",
  "通用.上传成功": "Upload succeeded",
  "通用.中文": "Chinese",
  "通用.保存": "Save",
  "通用.保存失败": "Save failed",
  "通用.保存失败重试": "Save failed, please retry",
  "通用.保存成功": "Saved",
  "通用.停用": "Inactive",
  "通用.创建失败": "Create failed",
  "通用.创建失败重试": "Create failed, please retry",
  "通用.创建成功": "Created",
  "通用.删除": "Delete",
  "通用.删除失败": "Delete failed",
  "通用.删除失败重试": "Delete failed, please retry",
  "通用.删除成功": "Deleted",
  "通用.加载中": "Loading...",
  "通用.取消": "Cancel",
  "通用.同步失败": "Sync failed",
  "通用.同步失败重试": "Sync failed, please retry",
  "通用.同步成功": "Synced",
  "通用.名称": "Name",
  "通用.名称不能为空": "Name is required",
  "通用.启用": "Active",
  "通用.备注": "Remark",
  "通用.导出": "Export",
  "通用.导出失败": "Export failed, please retry",
  "通用.导出成功": "Export succeeded",
  "通用.展开": "Expand",
  "通用.批量删除": "Batch delete",
  "通用.操作": "Actions",
  "通用.收起": "Collapse",
  "通用.新建": "New",
  "通用.暂无可导出数据": "No data to export",
  "通用.更换图片": "Replace image",
  "通用.更新失败": "Update failed",
  "通用.更新失败重试": "Update failed, please retry",
  "通用.更新成功": "Updated",
  "通用.查询": "Query",
  "通用.添加失败": "Add failed",
  "通用.添加失败重试": "Add failed, please retry.",
  "通用.添加成功": "Added",
  "通用.状态": "Status",
  "通用.确定": "OK",
  "通用.禁用": "Disabled",
  "通用.系统": "System",
  "通用.编辑": "Edit",
  "通用.英文": "English",
  "通用.请输入": "Please enter",
  "通用.请输入备注": "Remark (optional)",
  "通用.请选择": "Please select",
  "通用.选择图片": "Select image",
  "通用.重置": "Reset",
  "通用.重置失败": "Reset failed",
  "通用.重置成功": "Reset successful",
  "通用.重试": "Retry",
  "通用.高棉语": "Khmer",
  "错误.登录已过期": "Login expired, please sign in again",
  "错误.网络错误": "Network error, please check your connection",
  "错误.请求失败": "Request failed",
  "错误.请求错误": "Request error, please retry",
  "页面.403.无权限": "You do not have permission to access this page.",
  "页面.403.返回首页": "Back to Home",
  "页面.404.抱歉": "Sorry, the page you visited does not exist.",
  "页面.404.返回首页": "Back to Home",
  "页面.Bot测试.ID格式": "Enter a valid numeric Telegram ID",
  "页面.Bot测试.TGID": "Telegram user ID",
  "页面.Bot测试.兜底": "Channel · Without a profile",
  "页面.Bot测试.分组": "Copy variant",
  "页面.Bot测试.分组.A": "A · With location",
  "页面.Bot测试.分组.auto": "Automatic",
  "页面.Bot测试.分组.B": "B · Without location",
  "页面.Bot测试.参数": "Test settings",
  "页面.Bot测试.发送": "Send test",
  "页面.Bot测试.发送未知": "Delivery is unconfirmed. Check Telegram before sending again.",
  "页面.Bot测试.场景": "Scenario",
  "页面.Bot测试.场景.generic_jobs": "App · General jobs",
  "页面.Bot测试.场景.im": "Unread IM reminder",
  "页面.Bot测试.场景.jd_contact": "Job contact card (sample)",
  "页面.Bot测试.场景.location_jobs": "App · Area",
  "页面.Bot测试.场景.matched_jobs": "App · Job and area",
  "页面.Bot测试.场景.onboarding": "Welcome message",
  "页面.Bot测试.场景.position_jobs": "App · Job type",
  "页面.Bot测试.场景.reply": "Reply to user message",
  "页面.Bot测试.场景.resume_contact": "Resume contact card (sample)",
  "页面.Bot测试.填写工种": "Enter a job type",
  "页面.Bot测试.填写接收人": "Enter a recipient ID",
  "页面.Bot测试.就绪": "Ready",
  "页面.Bot测试.岗位": "Channel · With a profile",
  "页面.Bot测试.岗位数": "Simulated job count",
  "页面.Bot测试.工种": "Job type",
  "页面.Bot测试.工种编码": "App job code (optional)",
  "页面.Bot测试.平台ID": "Platform user ID",
  "页面.Bot测试.接收人": "Recipient",
  "页面.Bot测试.接收身份": "Recipient role",
  "页面.Bot测试.未就绪": "Unavailable",
  "页面.Bot测试.标题": "Bot Activation Test",
  "页面.Bot测试.模式": "Test mode",
  "页面.Bot测试.模拟": "Use test parameters",
  "页面.Bot测试.模拟地区": "Sample location",
  "页面.Bot测试.模拟姓名": "Sample name",
  "页面.Bot测试.模拟描述": "Message preview / requirements / skills",
  "页面.Bot测试.模拟说明": "Sends a real message with test parameters without using the live allowance. The recipient must have started this Bot.",
  "页面.Bot测试.求职者": "Job seeker",
  "页面.Bot测试.状态.activation_disabled": "Live activation is disabled. Use test parameters instead.",
  "页面.Bot测试.状态.already_in_channel": "Already in the channel",
  "页面.Bot测试.状态.ambiguous_user": "Multiple accounts found. Use a Telegram user ID.",
  "页面.Bot测试.状态.app_url_missing": "App return URL is not configured",
  "页面.Bot测试.状态.bot_unavailable": "The Bot is unavailable",
  "页面.Bot测试.状态.channel_membership_unknown": "Cannot check membership. Add the Bot as a channel admin.",
  "页面.Bot测试.状态.channel_missing": "Target channel is not configured",
  "页面.Bot测试.状态.duplicate": "This test was already processed",
  "页面.Bot测试.状态.failed": "Delivery failed or is unconfirmed. Check Telegram and service logs.",
  "页面.Bot测试.状态.frequency_limited": "Today’s activation allowance is used",
  "页面.Bot测试.状态.insufficient_jobs": "Not enough jobs to send",
  "页面.Bot测试.状态.no_candidate": "No match. Check seeker status, profile, scenario and today’s jobs.",
  "页面.Bot测试.状态.rate_limited": "Too frequent. Preview again shortly.",
  "页面.Bot测试.状态.ready": "Ready to send",
  "页面.Bot测试.状态.recent_campaign": "Recently reached by another campaign",
  "页面.Bot测试.状态.sent": "Submitted to Telegram",
  "页面.Bot测试.状态.tracking_missing": "Click tracking URL is not configured",
  "页面.Bot测试.状态.unreachable": "The user has not started this Bot or the chat is inactive",
  "页面.Bot测试.状态.unsubscribed": "Job reminders disabled",
  "页面.Bot测试.状态.user_not_found": "No linked Telegram user found",
  "页面.Bot测试.真实": "Use live rules",
  "页面.Bot测试.真实说明": "Uses live profile and today’s jobs. Sending consumes today’s activation allowance.",
  "页面.Bot测试.空预览": "Choose a recipient to preview the message and eligibility",
  "页面.Bot测试.触发测试说明": "Tests existing templates only, without triggering real IM or resume access. Contact cards use sample data and link to the test recipient; job cards are previewed as text.",
  "页面.Bot测试.语言": "Message language",
  "页面.Bot测试.请求失败": "Could not load. Try again.",
  "页面.Bot测试.连接": "Bot status",
  "页面.Bot测试.重试": "Retry",
  "页面.Bot测试.门槛": "Minimum jobs",
  "页面.Bot测试.雇主": "Employer",
  "页面.Bot测试.预览": "Preview message",
  "页面.Facebook推送测试.页面标题": "Facebook Push Test",
  "页面.Facebook推送测试.页面说明": "Test Facebook reauthorization by user ID without restricting the Facebook App ID. Only the latest active device is targeted.",
  "页面.Facebook矩阵.数据源配置.分类": "Category",
  "页面.Facebook矩阵.数据源配置.分类名称": "Category name",
  "页面.Facebook矩阵.数据源配置.分类名称占位": "e.g. Job groups",
  "页面.Facebook矩阵.数据源配置.分类名称必填": "Please enter category name",
  "页面.Facebook矩阵.数据源配置.创建时间": "Created at",
  "页面.Facebook矩阵.数据源配置.名称": "Name",
  "页面.Facebook矩阵.数据源配置.名称必填": "Please enter name",
  "页面.Facebook矩阵.数据源配置.名称说明": "Display name for admin",
  "页面.Facebook矩阵.数据源配置.备注": "Description",
  "页面.Facebook矩阵.数据源配置.备注占位": "Optional description",
  "页面.Facebook矩阵.数据源配置.外部实体ID": "External entity ID",
  "页面.Facebook矩阵.数据源配置.外部实体ID占位": "Optional, ID in external service",
  "页面.Facebook矩阵.数据源配置.实体类型": "Entity type",
  "页面.Facebook矩阵.数据源配置.实体类型主页": "Page",
  "页面.Facebook矩阵.数据源配置.实体类型帖子": "Post",
  "页面.Facebook矩阵.数据源配置.实体类型群组": "Group",
  "页面.Facebook矩阵.数据源配置.实体类型频道": "Channel",
  "页面.Facebook矩阵.数据源配置.实体链接": "Entity URL",
  "页面.Facebook矩阵.数据源配置.实体链接必填": "Please enter entity URL",
  "页面.Facebook矩阵.数据源配置.实体链接说明": "Facebook permalink",
  "页面.Facebook矩阵.数据源配置.成功删除N个": "Deleted {n}",
  "页面.Facebook矩阵.数据源配置.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.Facebook矩阵.数据源配置.按分类查看": "Data sources by category",
  "页面.Facebook矩阵.数据源配置.按实体类型查看": "Data sources by entity type",
  "页面.Facebook矩阵.数据源配置.数据源数": "Data sources",
  "页面.Facebook矩阵.数据源配置.新建分类": "New category",
  "页面.Facebook矩阵.数据源配置.新建数据源": "New data source",
  "页面.Facebook矩阵.数据源配置.更新时间": "Updated at",
  "页面.Facebook矩阵.数据源配置.未分类": "Uncategorized",
  "页面.Facebook矩阵.数据源配置.标题": "FB Data Sources",
  "页面.Facebook矩阵.数据源配置.正在删除N个": "Deleting {n}...",
  "页面.Facebook矩阵.数据源配置.正在更新": "Updating...",
  "页面.Facebook矩阵.数据源配置.正在添加": "Adding...",
  "页面.Facebook矩阵.数据源配置.状态已拒绝": "Rejected",
  "页面.Facebook矩阵.数据源配置.状态待审核": "Pending review",
  "页面.Facebook矩阵.数据源配置.确定删除": "Delete this data source?",
  "页面.Facebook矩阵.数据源配置.确定删除分类": "Delete this category? Its data sources will become uncategorized.",
  "页面.Facebook矩阵.数据源配置.管理分类": "Manage categories",
  "页面.Facebook矩阵.数据源配置.编辑分类": "Edit category",
  "页面.Facebook矩阵.数据源配置.编辑数据源": "Edit data source",
  "页面.Facebook矩阵.数据源配置.选择分类": "Please select category",
  "页面.Telegram矩阵.ClientKey创建": "Client Key",
  "页面.Telegram矩阵.云端托管": "Cloud-hosted",
  "页面.Telegram矩阵.创建方式": "Create method",
  "页面.Telegram矩阵.客户端上报": "Client report",
  "页面.Telegram矩阵.扫码授权云端托管": "QR auth (cloud-hosted)",
  "页面.Telegram矩阵.新增授权账号": "Add auth account",
  "页面.Telegram矩阵.账号类型": "Account type",
  "页面.Telegram矩阵.通过ClientKey创建客户端上报": "Create by Client Key (client report)",
  "页面.企业.Logo": "Logo",
  "页面.企业.Logo说明": "Company logo",
  "页面.企业.Telegram用户ID": "Telegram user ID",
  "页面.企业.Telegram用户名": "Telegram username",
  "页面.企业.上传Logo": "Upload logo",
  "页面.企业.上传媒体": "Upload media",
  "页面.企业.上传认证材料": "Upload verification",
  "页面.企业.代发岗位": "Post jobs",
  "页面.企业.企业ID": "Company ID",
  "页面.企业.企业ID点击详情": "Company ID, click for detail",
  "页面.企业.企业Logo": "Company logo",
  "页面.企业.企业Logoextra": "JPG/PNG, max 5MB",
  "页面.企业.企业Logotooltip": "1:1 crop, fallback to initial",
  "页面.企业.企业信息": "Company info",
  "页面.企业.企业全称": "Full name",
  "页面.企业.企业全称说明": "Full name (unique)",
  "页面.企业.企业全称长度2到50": "Full name 2-50 characters",
  "页面.企业.企业简称": "Short name",
  "页面.企业.企业简称不能超过20": "Short name max 20 characters",
  "页面.企业.企业管理": "Company management",
  "页面.企业.企业规模": "Scale",
  "页面.企业.企业详情": "Company detail",
  "页面.企业.信任背书": "Trust",
  "页面.企业.修改者": "Updated by",
  "页面.企业.公司地址": "Company address",
  "页面.企业.公司地址tooltip": "Map or manual",
  "页面.企业.公司环境媒体": "Environment media",
  "页面.企业.公司环境媒体extra": "JPG/PNG/MP4/MOV, max 50MB",
  "页面.企业.公司环境媒体tooltip": "Max 9 files (image/video)",
  "页面.企业.公司简介": "Description",
  "页面.企业.公司简介placeholder": "AI polish supported",
  "页面.企业.关键词搜索": "Keyword",
  "页面.企业.关键词搜索说明": "Search full/short name etc.",
  "页面.企业.创建失败": "Create failed",
  "页面.企业.创建失败请重试": "Create failed, please retry",
  "页面.企业.创建成功": "Created",
  "页面.企业.创建时间": "Created at",
  "页面.企业.创建时间说明": "Created at, hover for raw",
  "页面.企业.删除": "Delete",
  "页面.企业.删除后可以恢复": "Can be restored, but will not show in list.",
  "页面.企业.删除失败请重试": "Delete failed, please retry",
  "页面.企业.发布岗位数量": "Published jobs",
  "页面.企业.取消": "Cancel",
  "页面.企业.在招岗位": "Hiring jobs",
  "页面.企业.基础信息": "Basic info",
  "页面.企业.备注": "Remark",
  "页面.企业.备注placeholder": "Internal only, for review notes",
  "页面.企业.备注不能超过500": "Remark max 500 characters",
  "页面.企业.已认证": "Verified",
  "页面.企业.成功删除N个企业": "Deleted {count} companies",
  "页面.企业.成功删除N个失败M个": "Deleted {success}, failed {fail}",
  "页面.企业.所属行业": "Industry",
  "页面.企业.手动填写地址": "Manual address: ",
  "页面.企业.手动填写非标地址": "Enter address manually",
  "页面.企业.批量删除": "Batch delete",
  "页面.企业.提交": "Submit",
  "页面.企业.提交失败请重试": "Submit failed, please retry",
  "页面.企业.操作": "Actions",
  "页面.企业.支持国际区号格式": "e.g. +855",
  "页面.企业.收起手动填写": "Collapse manual",
  "页面.企业.新建企业": "New company",
  "页面.企业.无Logo": "Without logo",
  "页面.企业.时间信息": "Time info",
  "页面.企业.是否有Logo": "Company logo",
  "页面.企业.更新失败": "Update failed",
  "页面.企业.更新失败请重试": "Update failed, please retry",
  "页面.企业.更新成功": "Updated",
  "页面.企业.更新时间": "Updated at",
  "页面.企业.更新时间范围": "Updated time",
  "页面.企业.有Logo": "With logo",
  "页面.企业.未认证": "Unverified",
  "页面.企业.正在创建": "Creating...",
  "页面.企业.正在删除N个企业": "Deleting {count} companies...",
  "页面.企业.正在更新": "Updating...",
  "页面.企业.确定要删除这个企业吗": "Delete this company?",
  "页面.企业.编辑": "Edit",
  "页面.企业.编辑企业": "Edit company",
  "页面.企业.联系人": "Contact",
  "页面.企业.联系人信息": "Contact info",
  "页面.企业.联系人姓名": "Contact name",
  "页面.企业.联系人姓名不能超过50": "Contact name max 50 characters",
  "页面.企业.联系人职位": "Contact position",
  "页面.企业.联系人职位不能超过50": "Position max 50 characters",
  "页面.企业.联系电话": "Phone",
  "页面.企业.联系电话不能超过20": "Phone max 20 characters",
  "页面.企业.获取详情失败": "Failed to load detail",
  "页面.企业.获取详情失败请重试": "Failed to load detail, please retry",
  "页面.企业.裁剪Logo": "Crop logo",
  "页面.企业.认证材料": "Verification materials",
  "页面.企业.认证材料extra": "JPG/PNG/PDF, single file max 10MB",
  "页面.企业.认证材料格式说明": "JPG/PNG/PDF, max 10 files",
  "页面.企业.认证状态": "Verified",
  "页面.企业.认证状态开启说明": "Show verified badge and ranking boost",
  "页面.企业.请输入企业全称": "Enter full name",
  "页面.企业.请输入企业简称可选": "Enter short name (optional)",
  "页面.企业.请输入公司地址非标地址": "Enter company address (non-standard)",
  "页面.企业.请输入联系人姓名": "Enter contact name",
  "页面.企业.请输入联系人职位": "Enter position",
  "页面.企业.请选择企业规模": "Select scale",
  "页面.企业.请选择所属行业": "Select industry",
  "页面.企业.选择修改员工": "Select staff",
  "页面.企业配置.企业规模": "Company size",
  "页面.企业配置.创建时间": "Created at",
  "页面.企业配置.创建时间说明": "Created at, hover for raw",
  "页面.企业配置.删除": "Delete",
  "页面.企业配置.删除失败请重试": "Delete failed, please retry",
  "页面.企业配置.名称": "Name",
  "页面.企业配置.名称value字段": "Name (value)",
  "页面.企业配置.名称不能为空": "Name is required",
  "页面.企业配置.启用": "Enabled",
  "页面.企业配置.成功删除N个": "Deleted {count} {typeLabel}",
  "页面.企业配置.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.企业配置.批量删除": "Batch delete",
  "页面.企业配置.排序": "Order",
  "页面.企业配置.排序顺序说明": "Smaller = higher rank",
  "页面.企业配置.操作": "Actions",
  "页面.企业配置.新建": "New {typeLabel}",
  "页面.企业配置.新建行业": "New industry",
  "页面.企业配置.是否启用": "Active",
  "页面.企业配置.更新失败": "Update failed",
  "页面.企业配置.更新失败请重试": "Update failed, please retry",
  "页面.企业配置.更新成功": "Updated",
  "页面.企业配置.正在删除N个": "Deleting {count} {typeLabel}...",
  "页面.企业配置.正在更新": "Updating...",
  "页面.企业配置.正在添加": "Adding...",
  "页面.企业配置.添加失败": "Add failed",
  "页面.企业配置.添加失败请重试": "Add failed, please retry",
  "页面.企业配置.添加子级": "Add child",
  "页面.企业配置.添加成功": "Added",
  "页面.企业配置.状态": "Status",
  "页面.企业配置.确定删除行业项": "Delete this industry item? Children will be deleted too.",
  "页面.企业配置.确定要删除这个吗": "Delete this {typeLabel}?",
  "页面.企业配置.禁用": "Disabled",
  "页面.企业配置.管理": "{typeLabel} management",
  "页面.企业配置.编辑": "Edit",
  "页面.企业配置.编辑类型": "Edit {typeLabel}",
  "页面.企业配置.行业": "Industry",
  "页面.企业配置.配置": "Config",
  "页面.内容.创建时间": "Created at",
  "页面.内容.合作媒体.Logo图片": "Logo",
  "页面.内容.合作媒体.Logo链接": "Logo URL",
  "页面.内容.合作媒体.上传Logo": "Upload logo",
  "页面.内容.合作媒体.媒体名称": "Media name",
  "页面.内容.合作媒体.媒体名称占位": "Enter media name",
  "页面.内容.合作媒体.官网链接": "Website",
  "页面.内容.合作媒体.展示名称": "Display name",
  "页面.内容.合作媒体.成功删除N个": "Deleted {n} partners",
  "页面.内容.合作媒体.成功删除部分失败": "Deleted {ok}; {fail} failed",
  "页面.内容.合作媒体.新建": "New partner",
  "页面.内容.合作媒体.新建标题": "New media partner",
  "页面.内容.合作媒体.正在删除N个": "Deleting {n} partners...",
  "页面.内容.合作媒体.正在更新": "Updating...",
  "页面.内容.合作媒体.正在添加": "Adding...",
  "页面.内容.合作媒体.确定删除": "Delete this media partner?",
  "页面.内容.合作媒体.确定删除N个": "Delete {n} selected media partners?",
  "页面.内容.合作媒体.编辑标题": "Edit media partner",
  "页面.内容.合作媒体.联系人": "Contact",
  "页面.内容.合作媒体.联系电话": "Phone",
  "页面.内容.合作媒体.裁剪Logo": "Crop logo",
  "页面.内容.合作媒体.请输入媒体名称": "Media name is required",
  "页面.内容.合作媒体.页面标题": "Media Partners",
  "页面.内容.排序": "Order",
  "页面.内容.请补全多语言": "Complete all languages",
  "页面.内容.资讯.上传封面": "Upload cover",
  "页面.内容.资讯.价格": "Price",
  "页面.内容.资讯.加载合作媒体失败": "Failed to load media partners",
  "页面.内容.资讯.原文链接": "Source URL",
  "页面.内容.资讯.发布平台": "Platform",
  "页面.内容.资讯.发布时间": "Published at",
  "页面.内容.资讯.发布状态": "Status",
  "页面.内容.资讯.发布链接": "Published link",
  "页面.内容.资讯.合作媒体": "Media partner",
  "页面.内容.资讯.封面图片": "Cover image",
  "页面.内容.资讯.封面链接": "Cover URL",
  "页面.内容.资讯.已下架": "Offline",
  "页面.内容.资讯.已发布": "Published",
  "页面.内容.资讯.成功删除N个": "Deleted {n} articles",
  "页面.内容.资讯.成功删除部分失败": "Deleted {ok}; {fail} failed",
  "页面.内容.资讯.摘要": "Summary",
  "页面.内容.资讯.文章链接": "Article links",
  "页面.内容.资讯.新建": "New article",
  "页面.内容.资讯.新建标题": "New article",
  "页面.内容.资讯.标题": "Title",
  "页面.内容.资讯.正在删除N个": "Deleting {n} articles...",
  "页面.内容.资讯.正在更新": "Updating...",
  "页面.内容.资讯.正在添加": "Adding...",
  "页面.内容.资讯.正文": "Content",
  "页面.内容.资讯.添加文章链接": "Add article link",
  "页面.内容.资讯.确定删除": "Delete this article?",
  "页面.内容.资讯.确定删除N个": "Delete {n} selected articles?",
  "页面.内容.资讯.编辑标题": "Edit article",
  "页面.内容.资讯.草稿": "Draft",
  "页面.内容.资讯.裁剪封面": "Crop cover",
  "页面.内容.资讯.请输入发布平台": "Platform is required",
  "页面.内容.资讯.请输入发布链接": "Published link is required",
  "页面.内容.资讯.请输入正文": "Content is required",
  "页面.内容.资讯.请选择合作媒体": "Select a media partner",
  "页面.内容.资讯.页面标题": "Articles",
  "页面.反馈.举报人ID": "Reporter ID",
  "页面.反馈.举报人ID说明": "User ID that submitted this resume report.",
  "页面.反馈.举报原因": "Report reason",
  "页面.反馈.举报原因说明": "From the resume_complaint_type dictionary. Filterable by reason.",
  "页面.反馈.举报说明": "Report details",
  "页面.反馈.举报说明说明": "Details entered by the user; required when the reason is Other.",
  "页面.反馈.内容": "Content",
  "页面.反馈.内容说明": "Feedback content",
  "页面.反馈.创建时间": "Created at",
  "页面.反馈.创建时间说明": "Created at, hover for raw value",
  "页面.反馈.加载详情中": "Loading feedback detail...",
  "页面.反馈.反馈ID": "Feedback ID",
  "页面.反馈.反馈ID说明": "Feedback ID, click for details",
  "页面.反馈.岗位反馈记录.创建开始时间": "Created from",
  "页面.反馈.岗位反馈记录.创建时间": "Created at",
  "页面.反馈.岗位反馈记录.创建时间说明": "Created at, hover for raw value",
  "页面.反馈.岗位反馈记录.创建结束时间": "Created to",
  "页面.反馈.岗位反馈记录.加载详情中": "Loading feedback record detail...",
  "页面.反馈.岗位反馈记录.匿名ID": "Anonymous ID",
  "页面.反馈.岗位反馈记录.匿名ID说明": "anonymous_id used when a visitor submits feedback.",
  "页面.反馈.岗位反馈记录.反馈内容": "Feedback content",
  "页面.反馈.岗位反馈记录.反馈内容说明": "Free-text job feedback entered by the user.",
  "页面.反馈.岗位反馈记录.反馈记录ID": "Feedback record ID",
  "页面.反馈.岗位反馈记录.反馈记录ID说明": "Feedback record ID. Click to view details.",
  "页面.反馈.岗位反馈记录.反馈项": "Feedback items",
  "页面.反馈.岗位反馈记录.反馈项说明": "Job feedback items submitted by C-end users, from the jd_feedback_type dictionary.",
  "页面.反馈.岗位反馈记录.岗位ID": "Job ID",
  "页面.反馈.岗位反馈记录.岗位ID说明": "Job ID being reported. Click to view job details.",
  "页面.反馈.岗位反馈记录.暂无数据": "No data",
  "页面.反馈.岗位反馈记录.用户ID": "User ID",
  "页面.反馈.岗位反馈记录.用户ID说明": "C-end user ID that submitted the feedback. Click to view user details.",
  "页面.反馈.岗位反馈记录.用户详情": "User Detail",
  "页面.反馈.岗位反馈记录.获取详情失败": "Failed to load detail",
  "页面.反馈.岗位反馈记录.详情标题": "Job Feedback Record Detail",
  "页面.反馈.岗位反馈记录.请求失败": "Request failed",
  "页面.反馈.岗位反馈记录.请选择反馈项": "Please select feedback item",
  "页面.反馈.岗位反馈记录.页面标题": "Job Feedback Records",
  "页面.反馈.岗位投诉列表.页面标题": "Job Complaints",
  "页面.反馈.意见反馈列表.页面标题": "Feedback List",
  "页面.反馈.投诉对象ID": "Target ID",
  "页面.反馈.投诉对象ID说明": "Complaint target ID",
  "页面.反馈.投诉对象类型": "Target type",
  "页面.反馈.投诉对象类型说明": "For example, jd",
  "页面.反馈.投诉类型": "Complaint type",
  "页面.反馈.投诉类型说明": "Job complaint type. Filterable on the job complaint list.",
  "页面.反馈.操作": "Actions",
  "页面.反馈.暂无数据": "No data",
  "页面.反馈.用户ID": "User ID",
  "页面.反馈.用户ID说明": "Submitter user ID, click for user detail",
  "页面.反馈.用户详情": "User Detail",
  "页面.反馈.简历ID": "Resume ID",
  "页面.反馈.简历ID说明": "Reported resume ID. Click to view resume detail.",
  "页面.反馈.简历投诉列表.页面标题": "Resume Complaints",
  "页面.反馈.简历投诉详情": "Resume Complaint Detail",
  "页面.反馈.类别": "Category",
  "页面.反馈.类别.岗位投诉": "Job complaint",
  "页面.反馈.类别.意见反馈": "Feedback",
  "页面.反馈.类别.简历投诉": "Resume complaint",
  "页面.反馈.类别说明": "Feedback category",
  "页面.反馈.类型.全部": "All",
  "页面.反馈.缺少详情参数": "Feedback detail parameters are missing",
  "页面.反馈.获取详情失败": "Failed to load feedback detail",
  "页面.反馈.被举报用户ID": "Reported user ID",
  "页面.反馈.被举报用户ID说明": "Resolved from the reported resume owner. Click for user detail.",
  "页面.反馈.详情标题": "Feedback Detail",
  "页面.反馈.请求失败": "Request failed",
  "页面.反馈.请选择举报原因": "Please select a report reason",
  "页面.反馈.请选择投诉类型": "Please select complaint type",
  "页面.反馈.账号申诉.凭证文件": "Evidence files",
  "页面.反馈.账号申诉.加载详情中": "Loading appeal detail...",
  "页面.反馈.账号申诉.处理失败": "Failed to process the account appeal",
  "页面.反馈.账号申诉.处理成功": "Appeal approved and restriction lifted",
  "页面.反馈.账号申诉.审核人ID": "Reviewer ID",
  "页面.反馈.账号申诉.审核回复": "Review response",
  "页面.反馈.账号申诉.审核时间": "Reviewed at",
  "页面.反馈.账号申诉.提交时间": "Submitted at",
  "页面.反馈.账号申诉.暂无数据": "No appeal data",
  "页面.反馈.账号申诉.状态": "Appeal status",
  "页面.反馈.账号申诉.状态.审核中": "Reviewing",
  "页面.反馈.账号申诉.状态.已提交": "Submitted",
  "页面.反馈.账号申诉.状态.已通过": "Approved",
  "页面.反馈.账号申诉.状态.已驳回": "Rejected",
  "页面.反馈.账号申诉.用户": "User",
  "页面.反馈.账号申诉.用户ID": "User ID",
  "页面.反馈.账号申诉.申诉ID": "Appeal ID",
  "页面.反馈.账号申诉.申诉原因": "Appeal reason",
  "页面.反馈.账号申诉.申诉编号": "Appeal number",
  "页面.反馈.账号申诉.申诉说明": "Appeal details",
  "页面.反馈.账号申诉.确认解除封禁": "Approve the appeal and unblock the account?",
  "页面.反馈.账号申诉.确认解除禁言": "Approve the appeal and remove the IM mute?",
  "页面.反馈.账号申诉.确认解除说明": "The appeal will be approved and the matching restriction will be lifted immediately.",
  "页面.反馈.账号申诉.获取详情失败": "Failed to load appeal detail",
  "页面.反馈.账号申诉.解除封禁": "Unblock",
  "页面.反馈.账号申诉.解除时间": "Lifted at",
  "页面.反馈.账号申诉.解除禁言": "Unmute",
  "页面.反馈.账号申诉.详情标题": "Account Appeal Detail",
  "页面.反馈.账号申诉.账号": "Account",
  "页面.反馈.账号申诉.限制原因": "Restriction reason",
  "页面.反馈.账号申诉.限制开始时间": "Restriction started",
  "页面.反馈.账号申诉.限制状态": "Restriction status",
  "页面.反馈.账号申诉.限制状态.已到期": "Expired",
  "页面.反馈.账号申诉.限制状态.已解除": "Lifted",
  "页面.反馈.账号申诉.限制状态.生效中": "Active",
  "页面.反馈.账号申诉.限制类型": "Restriction type",
  "页面.反馈.账号申诉.限制类型.封禁": "Account ban",
  "页面.反馈.账号申诉.限制类型.禁言": "IM mute",
  "页面.反馈.账号申诉.限制结束时间": "Scheduled end",
  "页面.反馈.账号申诉.限制说明": "Restriction details",
  "页面.反馈.账号申诉.页面标题": "Account Appeals",
  "页面.反馈.账号限制.匿名简历": "Anonymous resume",
  "页面.反馈.账号限制.封禁": "Ban",
  "页面.反馈.账号限制.封禁成功": "User banned",
  "页面.反馈.账号限制.已封禁": "Banned",
  "页面.反馈.账号限制.已禁言": "Muted",
  "页面.反馈.账号限制.操作失败": "Failed to update account restriction",
  "页面.反馈.账号限制.无账号": "No account",
  "页面.反馈.账号限制.正常": "Normal",
  "页面.反馈.账号限制.状态": "Account restriction",
  "页面.反馈.账号限制.状态说明": "Current mute or ban status of the reported user.",
  "页面.反馈.账号限制.确认封禁": "Ban this user?",
  "页面.反馈.账号限制.确认封禁说明": "The user loses access to signed-in App APIs but can still submit an account appeal.",
  "页面.反馈.账号限制.确认禁言": "Mute this user?",
  "页面.反馈.账号限制.确认禁言说明": "The user cannot send IM messages but can still use other signed-in features.",
  "页面.反馈.账号限制.确认解除": "Lift the current restriction?",
  "页面.反馈.账号限制.禁言": "Mute",
  "页面.反馈.账号限制.禁言成功": "User muted",
  "页面.反馈.账号限制.解除": "Lift",
  "页面.反馈.账号限制.解除成功": "Restriction lifted",
  "页面.员工.APIKey名称": "API Key name",
  "页面.员工.HTTP方法": "HTTP method",
  "页面.员工.Trace ID": "Trace ID",
  "页面.员工.User-Agent": "User-Agent",
  "页面.员工.仅支持小写字母数字下划线": "Lowercase letters, numbers, underscore only",
  "页面.员工.保存角色权限": "Save role permissions",
  "页面.员工.全部操作记录": "All operation logs",
  "页面.员工.关联账号": "Linked account",
  "页面.员工.关联账号占位": "e.g. call center login email",
  "页面.员工.关联账号说明": "Matches your call center login (e.g. OMICall) for one-to-one outbound calling",
  "页面.员工.关键词搜索": "Keyword",
  "页面.员工.分配角色": "Assign Roles",
  "页面.员工.创建失败": "Create failed",
  "页面.员工.创建失败重试": "Create failed, please retry",
  "页面.员工.创建成功": "Created",
  "页面.员工.创建时间": "Created at",
  "页面.员工.删除后该账号将无法登录": "Account cannot login after delete.",
  "页面.员工.删除失败": "Delete failed",
  "页面.员工.删除失败重试": "Delete failed, please retry",
  "页面.员工.删除成功": "Deleted",
  "页面.员工.删除角色不可恢复": "This action cannot be undone.",
  "页面.员工.刷新": "Refresh",
  "页面.员工.加载权限目录失败": "Failed to load permissions",
  "页面.员工.加载权限目录失败重试": "Failed to load permissions, please retry",
  "页面.员工.加载角色失败": "Failed to load roles",
  "页面.员工.加载角色失败重试": "Failed to load roles, please retry",
  "页面.员工.同步Manifest": "Sync Manifest",
  "页面.员工.同步失败": "Sync failed",
  "页面.员工.同步失败重试": "Sync failed, please retry",
  "页面.员工.同步完成": "Synced: +{created}, ~{updated}, ={unchanged}",
  "页面.员工.员工列表": "Staff list",
  "页面.员工.客户端IP": "Client IP",
  "页面.员工.密码已重置": "Password reset",
  "页面.员工.当前可分配N项权限": "{n} permissions can be assigned. Click a name to toggle all leaves.",
  "页面.员工.当前角色": "Current role",
  "页面.员工.我的操作记录": "My operation logs",
  "页面.员工.按权限key搜索": "Search by permission key (e.g. staff.role)",
  "页面.员工.接口摘要": "Summary",
  "页面.员工.搜索用户名昵称": "Search username, nickname",
  "页面.员工.操作": "Actions",
  "页面.员工.操作人ID": "Operator ID",
  "页面.员工.操作时间": "Time",
  "页面.员工.操作时间范围": "Time range",
  "页面.员工.新密码": "New password",
  "页面.员工.新建角色": "New role",
  "页面.员工.昵称": "Nickname",
  "页面.员工.暂无可分配权限": "No assignable permissions",
  "页面.员工.暂无角色": "No roles yet",
  "页面.员工.更新失败": "Update failed",
  "页面.员工.更新失败重试": "Update failed, please retry",
  "页面.员工.更新成功": "Updated",
  "页面.员工.更新时间": "Updated at",
  "页面.员工.未激活": "Inactive",
  "页面.员工.权限可见即可编辑": "Visible permissions are editable",
  "页面.员工.权限可见即可编辑说明": "You can only see and edit permissions you have; changes are merged with the role.",
  "页面.员工.权限树配置": "Permission Tree",
  "页面.员工.查看": "View",
  "页面.员工.正在保存角色权限": "Saving role permissions...",
  "页面.员工.正在创建": "Creating...",
  "页面.员工.正在创建角色": "Creating role...",
  "页面.员工.正在删除": "Deleting...",
  "页面.员工.正在删除角色": "Deleting role...",
  "页面.员工.正在加载该角色权限": "Loading role permissions…",
  "页面.员工.正在同步权限清单": "Syncing permissions...",
  "页面.员工.正在更新": "Updating...",
  "页面.员工.正在更新角色": "Updating role...",
  "页面.员工.活跃": "Active",
  "页面.员工.状态": "Status",
  "页面.员工.状态码": "Status code",
  "页面.员工.用户ID": "User ID",
  "页面.员工.用户ID点击详情": "User ID, click for detail",
  "页面.员工.用户名": "Username",
  "页面.员工.确定要删除该员工吗": "Delete this staff?",
  "页面.员工.确认删除角色": "Delete this role?",
  "页面.员工.系统内置角色不允许删除": "System built-in roles cannot be deleted",
  "页面.员工.系统管理员不可修改": "System admin role cannot be edited here",
  "页面.员工.编辑": "Edit",
  "页面.员工.编辑角色": "Edit role",
  "页面.员工.至少8字符": "At least 8 characters",
  "页面.员工.获取详情失败": "Failed to load detail",
  "页面.员工.获取详情失败请重试": "Failed to load detail, please retry",
  "页面.员工.角色": "Roles",
  "页面.员工.角色名称": "Role name",
  "页面.员工.角色已更新": "Roles updated",
  "页面.员工.角色权限保存失败": "Failed to save role permissions",
  "页面.员工.角色权限保存失败重试": "Failed to save, please retry",
  "页面.员工.角色权限保存成功": "Role permissions saved",
  "页面.员工.角色权限只读": "Role permissions read-only",
  "页面.员工.角色管理": "Role Management",
  "页面.员工.角色编码": "Role code",
  "页面.员工.角色编码占位": "e.g. operation_manager",
  "页面.员工.认证方式": "Auth type",
  "页面.员工.记录ID": "Log ID",
  "页面.员工.请先在左侧选择角色": "Select a role on the left",
  "页面.员工.请先选择角色": "Please select a role first",
  "页面.员工.请求路径": "Path",
  "页面.员工.请输入新密码": "Please enter new password",
  "页面.员工.请输入角色名称": "Please enter role name",
  "页面.员工.请输入角色编码": "Please enter role code",
  "页面.员工.请选择状态": "Please select status",
  "页面.员工.请选择角色": "Select roles (multiple)",
  "页面.员工.路径关键词": "Path keyword",
  "页面.员工.重置密码": "Reset Password",
  "页面.商业化.拖拽调整权益顺序": "Drag to reorder benefits",
  "页面.审核记录.不通过原因": "Rejection reasons",
  "页面.审核记录.不通过原因.ID说明": "Rejection reason ID (code)",
  "页面.审核记录.不通过原因.创建时间": "Created at",
  "页面.审核记录.不通过原因.名称说明": "Reason name",
  "页面.审核记录.不通过原因.成功删除N个": "Deleted {n}",
  "页面.审核记录.不通过原因.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.审核记录.不通过原因.排序": "Sort",
  "页面.审核记录.不通过原因.新建": "New reason",
  "页面.审核记录.不通过原因.正在删除N个": "Deleting {n}...",
  "页面.审核记录.不通过原因.正在更新": "Updating...",
  "页面.审核记录.不通过原因.正在添加": "Adding...",
  "页面.审核记录.不通过原因.确定删除": "Delete this rejection reason?",
  "页面.审核记录.不通过原因.管理标题": "Rejection reasons",
  "页面.审核记录.不通过原因筛选": "Filter by rejection reason",
  "页面.审核记录.不通过原因管理": "Rejection reasons",
  "页面.审核记录.最近7天": "Last 7 days",
  "页面.审核记录.最近一个月": "Last 30 days",
  "页面.审核记录.审核备注": "Review remark",
  "页面.审核记录.审核记录": "Review records",
  "页面.审核记录.岗位视角": "By job",
  "页面.审核记录.当天": "Today",
  "页面.审核记录.时间": "Time",
  "页面.审核记录.查看岗位": "View job",
  "页面.审核记录.记录视角": "By record",
  "页面.审核记录.选择审核人": "Select reviewer",
  "页面.岗位.AI评分": "AI score",
  "页面.岗位.AI评分说明": "Shows AI grade, score, and reason summary",
  "页面.岗位.Boost状态": "Boost status",
  "页面.岗位.C端联系记录": "C-side contact records",
  "页面.岗位.N个文件上传失败": "{n} file(s) upload failed",
  "页面.岗位.Urgent": "Urgent",
  "页面.岗位.Urgent使用成功": "Urgent item used",
  "页面.岗位.上传岗位文件或图片": "Upload job file or image",
  "页面.岗位.上午": "AM",
  "页面.岗位.下午": "PM",
  "页面.岗位.下架": "Unpublish",
  "页面.岗位.下架失败": "Unpublish failed",
  "页面.岗位.下架失败重试": "Unpublish failed, please retry",
  "页面.岗位.下架成功": "Unpublished",
  "页面.岗位.不通过原因必选": "Rejection reasons (at least one)",
  "页面.岗位.不限": "Any",
  "页面.岗位.中文标签": "Chinese (zh_CN)",
  "页面.岗位.临时工": "Temporary",
  "页面.岗位.仅周末": "Weekend only",
  "页面.岗位.仅工作日": "Weekdays only",
  "页面.岗位.从输入定位圈定": "Apply selection from input",
  "页面.岗位.付费岗位": "Paid job",
  "页面.岗位.代发岗位场景企业不可修改": "Company preset for this job",
  "页面.岗位.任务ID": "Task ID",
  "页面.岗位.任务ID说明": "Task ID = generated by task, click for detail",
  "页面.岗位.任务列表": "Task list",
  "页面.岗位.任务已提交正在生成": "Submitted, generating...",
  "页面.岗位.任务正在后台生成中": "Tasks are generating",
  "页面.岗位.任务详情": "Task detail",
  "页面.岗位.任职要求": "Requirements",
  "页面.岗位.企业ID": "Company ID",
  "页面.岗位.企业关键词搜索": "Search company (min 2 chars, optional)",
  "页面.岗位.企业创建成功": "Company created and selected",
  "页面.岗位.企业名称": "Company",
  "页面.岗位.企业名称只读说明": "This is the original company name from source data, for reference only and not editable. Display uses the linked company above; please select or edit there.",
  "页面.岗位.企业名称表单说明": "Free-text company name on job",
  "页面.岗位.企业名称说明": "Unstructured company name on job",
  "页面.岗位.优先级": "Priority",
  "页面.岗位.使用Urgent": "Use Urgent",
  "页面.岗位.使用Urgent扣减说明": "This will use 1 Urgent item from the linked user and refresh the job ranking. Continue?",
  "页面.岗位.全职": "Full-time",
  "页面.岗位.全选": "Select all",
  "页面.岗位.全部": "All",
  "页面.岗位.全部岗位": "All jobs",
  "页面.岗位.全部语言不传": "All languages",
  "页面.岗位.公海池": "Pool",
  "页面.岗位.共N条": "Total {total}",
  "页面.岗位.关联企业": "Company",
  "页面.岗位.关联企业搜索说明": "Search by name, min 2 chars; no selection = pool",
  "页面.岗位.关联企业说明": "Company ID, click for detail",
  "页面.岗位.关键词匹配说明": "Match title, duties, benefits, etc.",
  "页面.岗位.关键词搜索": "Keyword",
  "页面.岗位.关闭": "Close",
  "页面.岗位.兼职": "Part-time",
  "页面.岗位.内容文件": "Files",
  "页面.岗位.内容文本": "Text",
  "页面.岗位.最大年龄": "Maximum age",
  "页面.岗位.最大薪资美元": "Max salary (USD)",
  "页面.岗位.最小年龄": "Minimum age",
  "页面.岗位.最小年龄不能大于最大年龄": "Minimum age cannot be greater than maximum age",
  "页面.岗位.最小薪资美元": "Min salary (USD)",
  "页面.岗位.最近7天": "Last 7 days",
  "页面.岗位.最近一个月": "Last 30 days",
  "页面.岗位.最近提交翻译时间": "Last translation at",
  "页面.岗位.分数": "Score",
  "页面.岗位.分配": "Assign",
  "页面.岗位.分配人": "Assignee",
  "页面.岗位.分配任务管理": "Review assignment",
  "页面.岗位.分配工作台": "Assignment workspace",
  "页面.岗位.分配成功": "Assigned successfully",
  "页面.岗位.分配数量": "Assign count",
  "页面.岗位.分配数量占位": "Leave empty to assign all in group",
  "页面.岗位.分配数量范围提示": "Assign count must be between 1 and {max}",
  "页面.岗位.分配状态": "Assignment status",
  "页面.岗位.分配管理": "Assignment",
  "页面.岗位.分配结果": "Assignment result",
  "页面.岗位.分配给该组": "Assign to…",
  "页面.岗位.分配维度": "Assignment",
  "页面.岗位.创建": "Created",
  "页面.岗位.创建时间": "Created at",
  "页面.岗位.创建时间说明": "Created at, hover for raw",
  "页面.岗位.删除岗位可恢复说明": "Can be restored but will not show in list.",
  "页面.岗位.刷新概览": "Refresh overview",
  "页面.岗位.区间止": "Range end (e.g. 20250305-000200)",
  "页面.岗位.区间止简版": "End no. (digits only)",
  "页面.岗位.区间起": "Range start (e.g. 20250305-000001)",
  "页面.岗位.区间起简版": "Start no. (digits only)",
  "页面.岗位.博士": "Doctor",
  "页面.岗位.原文": "Original",
  "页面.岗位.发布": "Publish",
  "页面.岗位.发布失败": "Publish failed",
  "页面.岗位.发布失败重试": "Publish failed, please retry",
  "页面.岗位.发布成功": "Published",
  "页面.岗位.发布时间": "Published at",
  "页面.岗位.发布来源": "Publish source",
  "页面.岗位.发布来源说明": "Filter by whether the job was self-published by a C-side user",
  "页面.岗位.发布状态": "Publish status",
  "页面.岗位.取消分配": "Unassign",
  "页面.岗位.取消分配成功": "Unassigned successfully",
  "页面.岗位.取消分配数量": "Unassign count",
  "页面.岗位.取消分配数量占位": "Leave empty to unassign all in group",
  "页面.岗位.取消分配数量范围提示": "Unassign count must be between 1 and {max}",
  "页面.岗位.取消分配结果": "Unassignment result",
  "页面.岗位.取消岗位置顶失败": "Failed to unpin job, please retry",
  "页面.岗位.取消岗位置顶成功": "Job unpinned",
  "页面.岗位.取消置顶": "Unpin",
  "页面.岗位.只支持文档和图片格式": "Only docs and images",
  "页面.岗位.合同工": "Contract",
  "页面.岗位.同步刷新": "Sync refresh",
  "页面.岗位.周": "Week",
  "页面.岗位.周一": "Mon",
  "页面.岗位.周一上午": "Mon AM",
  "页面.岗位.周一下午": "Mon PM",
  "页面.岗位.周三": "Wed",
  "页面.岗位.周三上午": "Wed AM",
  "页面.岗位.周三下午": "Wed PM",
  "页面.岗位.周二": "Tue",
  "页面.岗位.周二上午": "Tue AM",
  "页面.岗位.周二下午": "Tue PM",
  "页面.岗位.周五": "Fri",
  "页面.岗位.周五上午": "Fri AM",
  "页面.岗位.周五下午": "Fri PM",
  "页面.岗位.周六": "Sat",
  "页面.岗位.周六上午": "Sat AM",
  "页面.岗位.周六下午": "Sat PM",
  "页面.岗位.周四": "Thu",
  "页面.岗位.周四上午": "Thu AM",
  "页面.岗位.周四下午": "Thu PM",
  "页面.岗位.周日": "Sun",
  "页面.岗位.周日上午": "Sun AM",
  "页面.岗位.周日下午": "Sun PM",
  "页面.岗位.周结": "Weekly",
  "页面.岗位.基础信息": "Basic info",
  "页面.岗位.填入区间": "Fill range",
  "页面.岗位.复制失败请重试": "Copy failed, please retry",
  "页面.岗位.大专": "Vocational",
  "页面.岗位.女": "Female",
  "页面.岗位.学历要求": "Education",
  "页面.岗位.完工结算": "On completion",
  "页面.岗位.定位": "Locate",
  "页面.岗位.定位到我最后审核的": "Locate to my last review",
  "页面.岗位.定位失败重试": "Locate failed, please retry",
  "页面.岗位.实习": "Internship",
  "页面.岗位.审核": "Review",
  "页面.岗位.审核不通过": "Rejected",
  "页面.岗位.审核人": "Reviewer",
  "页面.岗位.审核信息": "Review info",
  "页面.岗位.审核备注选填": "Review remark (optional, max 500):",
  "页面.岗位.审核时间": "Reviewed at",
  "页面.岗位.审核状态": "Review status",
  "页面.岗位.审核通过": "Approved",
  "页面.岗位.审核通过但发布失败": "Approved but publish failed: {msg}",
  "页面.岗位.审核通过并已自动发布": "Approved and published",
  "页面.岗位.审核通过自动发布": "Auto publish when approved",
  "页面.岗位.岗位ID": "Job ID",
  "页面.岗位.岗位ID或编号": "Job ID or no.",
  "页面.岗位.岗位ID点击详情": "Job ID, click for detail",
  "页面.岗位.岗位ID精确查找": "Exact job ID",
  "页面.岗位.岗位信息": "Job info",
  "页面.岗位.岗位分组配置展示": "Job group configuration",
  "页面.岗位.岗位原文主体语言": "Title language",
  "页面.岗位.岗位原文主体语言说明": "Title main language: zh_CN / en_US / km_KH",
  "页面.岗位.岗位名称": "Job title",
  "页面.岗位.岗位名称长度": "1-100 characters",
  "页面.岗位.岗位地址": "Job address",
  "页面.岗位.岗位地址tooltip": "Map or manual",
  "页面.岗位.岗位审核": "Job review",
  "页面.岗位.岗位审核带ID": "Job review ({id})",
  "页面.岗位.岗位审核带标题": "Job review: {title}",
  "页面.岗位.岗位标签": "Job tags",
  "页面.岗位.岗位标签关键词": "Tag keyword",
  "页面.岗位.岗位标签关键词说明": "Search by tag keyword",
  "页面.岗位.岗位标签多选": "Job tags (multi)",
  "页面.岗位.岗位标签筛选说明": "Job tags; multi-select filter",
  "页面.岗位.岗位生成": "Job generation",
  "页面.岗位.岗位等级": "Job grade",
  "页面.岗位.岗位等级筛选说明": "Filter by AI job grade",
  "页面.岗位.岗位管理": "Job Management",
  "页面.岗位.岗位编号": "Job no.",
  "页面.岗位.岗位编号查找": "Exact job no. e.g. 20250226-000001",
  "页面.岗位.岗位置顶失败": "Failed to pin job, please retry",
  "页面.岗位.岗位置顶成功": "Job pinned",
  "页面.岗位.岗位翻译管理": "Job translation",
  "页面.岗位.岗位翻译管理带标题": "Job translation: {title}",
  "页面.岗位.岗位职责": "Job duties",
  "页面.岗位.岗位详情": "Job detail",
  "页面.岗位.工作地点": "Location",
  "页面.岗位.工作地点多选": "Location (multi)",
  "页面.岗位.工作开始时间": "Work start time",
  "页面.岗位.工作性质": "Employment type",
  "页面.岗位.工作日安排": "Workday schedule",
  "页面.岗位.工作福利标签": "Lexicon tags",
  "页面.岗位.工作福利标签列表说明": "From tag lexicon (multiple categories); dropdown shows active items only; table uses UI language; hover a tag for its category",
  "页面.岗位.工作经验要求": "Experience requirement",
  "页面.岗位.工作结束时间": "Work end time",
  "页面.岗位.工作职责": "Responsibilities",
  "页面.岗位.工作要求": "Work requirements",
  "页面.岗位.工种": "Job category",
  "页面.岗位.已Boost": "Boosted",
  "页面.岗位.已上架": "Listed",
  "页面.岗位.已下架": "Unpublished",
  "页面.岗位.已关联企业": "Assigned",
  "页面.岗位.已分配": "Assigned",
  "页面.岗位.已发布": "Published",
  "页面.岗位.已审核": "Reviewed",
  "页面.岗位.已提交翻译": "Translation submitted",
  "页面.岗位.已标记为审核不通过": "Marked as rejected",
  "页面.岗位.已标记为稍后审核": "Marked for later review",
  "页面.岗位.已添加N个文件任务": "Added {n} file(s)",
  "页面.岗位.已置顶": "Pinned",
  "页面.岗位.已跳过": "Skipped",
  "页面.岗位.已选N条": "Selected {n}",
  "页面.岗位.已预设企业不可修改": "Company preset",
  "页面.岗位.年龄要求": "Age requirement",
  "页面.岗位.开始生成": "Start",
  "页面.岗位.当前圈定": "Current selection",
  "页面.岗位.当前岗位未发布是否仍复制链接": "This job is not published. Copy link anyway?",
  "页面.岗位.当前数据条件": "Current filter",
  "页面.岗位.当前选中组": "Selected group",
  "页面.岗位.当天": "Today",
  "页面.岗位.待分配": "Unassigned",
  "页面.岗位.待发布": "To publish",
  "页面.岗位.待提交": "Pending",
  "页面.岗位.快速创建企业": "Quick create company",
  "页面.岗位.性别不限": "No limit",
  "页面.岗位.性别要求": "Gender requirement",
  "页面.岗位.成功N条失败N条": "Success {success}, failed {fail}",
  "页面.岗位.成功删除N个": "Deleted {n} jobs",
  "页面.岗位.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.岗位.我审核的": "My reviews",
  "页面.岗位.我的任务": "My tasks",
  "页面.岗位.所有任务执行失败": "All failed, {n} errors",
  "页面.岗位.所有任务执行完毕": "All done, {n} succeeded",
  "页面.岗位.手动圈定": "Manual targeting",
  "页面.岗位.手动填写地址": "Manual address: ",
  "页面.岗位.手动填写非标地址": "Enter address manually",
  "页面.岗位.执行配置": "Execution config",
  "页面.岗位.批次任务": "Batch (ID: {id})",
  "页面.岗位.批量上传文件": "Upload files",
  "页面.岗位.技能要求": "Skills",
  "页面.岗位.拉取该语言预览": "Fetch preview",
  "页面.岗位.拖拉圈定": "Drag to select range",
  "页面.岗位.招聘人数": "Headcount",
  "页面.岗位.按分配人筛选": "Filter by assignee",
  "页面.岗位.按区间分配": "Assign by range",
  "页面.岗位.按区间取消分配": "Unassign by range",
  "页面.岗位.按天分配概览": "Daily assignment overview",
  "页面.岗位.按编号分配": "Assign by job no.",
  "页面.岗位.按编号取消分配": "Unassign by job no.",
  "页面.岗位.按选中分配": "Assign selected",
  "页面.岗位.按选中取消分配": "Unassign selected",
  "页面.岗位.提交": "Submit",
  "页面.岗位.提交失败": "Submit failed",
  "页面.岗位.提交失败请重试": "Submit failed, please retry",
  "页面.岗位.提交失败重试": "Submit failed, please retry",
  "页面.岗位.提交并审核": "Submit and review",
  "页面.岗位.提交翻译": "Submit translation",
  "页面.岗位.提交翻译成功": "Translation submitted",
  "页面.岗位.操作分配人": "Operator assignee",
  "页面.岗位.操作失败": "Operation failed",
  "页面.岗位.操作失败重试": "Operation failed, please retry",
  "页面.岗位.收起手动填写": "Collapse manual",
  "页面.岗位.新建岗位": "New job",
  "页面.岗位.无法获取当前用户信息": "Cannot get current user",
  "页面.岗位.无额外条件": "No filter (all data)",
  "页面.岗位.日": "Day",
  "页面.岗位.日期提示文案": "Changing date auto-refreshes all segments of that day",
  "页面.岗位.日结": "Daily",
  "页面.岗位.时": "Hour",
  "页面.岗位.时间": "Time",
  "页面.岗位.时间信息": "Time info",
  "页面.岗位.昨天": "Yesterday",
  "页面.岗位.是否已提交翻译": "Translation submitted",
  "页面.岗位.暂无任务请点击添加": "No tasks, click above to add",
  "页面.岗位.暂无分组数据": "No groups (matches current list filter)",
  "页面.岗位.暂无匹配岗位分组配置": "The selected job tags do not match any job group configuration",
  "页面.岗位.暂无您的审核记录": "No review records from you",
  "页面.岗位.更多": "More",
  "页面.岗位.更新时间": "Updated at",
  "页面.岗位.月": "Month",
  "页面.岗位.月结": "Monthly",
  "页面.岗位.有未提交任务关闭说明": "Unsaved tasks will be cleared. Close?",
  "页面.岗位.未Boost": "Not boosted",
  "页面.岗位.未分配": "Unassigned",
  "页面.岗位.未审核": "Pending",
  "页面.岗位.本岗位审核记录": "Review records",
  "页面.岗位.本次工作台数据共N条": "Total {n} items in this workspace",
  "页面.岗位.本科": "Bachelor",
  "页面.岗位.本组共N条": "This group has {n} items",
  "页面.岗位.条数": "Count",
  "页面.岗位.来自岗位详情接口切换Tab不会清空": "From job detail API, switching tabs keeps data.",
  "页面.岗位.某语言预览拉取成功": "{lang} preview loaded",
  "页面.岗位.查看原文": "View original",
  "页面.岗位.查看审核记录": "View review records",
  "页面.岗位.查询成功": "Query success",
  "页面.岗位.查询状态": "Query status",
  "页面.岗位.查询翻译任务状态": "Translation status",
  "页面.岗位.校验失败": "Validation failed",
  "页面.岗位.正在上传文件并提交任务": "Uploading and submitting...",
  "页面.岗位.正在下架": "Unpublishing...",
  "页面.岗位.正在创建": "Creating...",
  "页面.岗位.正在删除N个": "Deleting {n} jobs...",
  "页面.岗位.正在发布": "Publishing...",
  "页面.岗位.正在取消置顶岗位": "Unpinning job...",
  "页面.岗位.正在打开上一条岗位": "Opening previous job...",
  "页面.岗位.正在打开下一条待审核": "Opening next pending job...",
  "页面.岗位.正在更新": "Updating...",
  "页面.岗位.正在标记稍后审核": "Marking review later...",
  "页面.岗位.正在置顶岗位": "Pinning job...",
  "页面.岗位.步骤1选择数据段": "Step 1: Select a segment",
  "页面.岗位.步骤2调整并提交": "Step 2: Adjust range and submit",
  "页面.岗位.池与关联": "Pool/Company",
  "页面.岗位.没有上一条可返回": "No previous job to return to",
  "页面.岗位.没有更多待审核岗位": "No more pending jobs",
  "页面.岗位.添加生成任务": "Add task",
  "页面.岗位.添加纯文本任务": "Add text task",
  "页面.岗位.清空": "Clear",
  "页面.岗位.点击展开查看完整返回": "Click to expand",
  "页面.岗位.用户": "User",
  "页面.岗位.用户ID": "User ID",
  "页面.岗位.用户ID说明": "C-side user ID, click for detail",
  "页面.岗位.用户信息说明": "User (empty if deleted)",
  "页面.岗位.男": "Male",
  "页面.岗位.目标语言": "Target language",
  "页面.岗位.硕士": "Master",
  "页面.岗位.确定关闭": "Close",
  "页面.岗位.确定删除岗位": "Delete this job?",
  "页面.岗位.确定取消该区间分配": "Unassign this range?",
  "页面.岗位.确定取消该组分配": "Unassign this group?",
  "页面.岗位.确认使用Urgent": "Confirm Urgent use",
  "页面.岗位.确认关闭": "Confirm close",
  "页面.岗位.福利待遇": "Benefits",
  "页面.岗位.稍后审核": "Review later",
  "页面.岗位.筛选.地点与标签": "Location & tags",
  "页面.岗位.筛选.基础信息": "Basic",
  "页面.岗位.筛选.岗位与池": "Job & pool",
  "页面.岗位.筛选.数据源": "Data source",
  "页面.岗位.筛选.联系与渠道": "Contact & channel",
  "页面.岗位.筛选.薪资与任职": "Salary & employment",
  "页面.岗位.管理分配任务": "Manage review assignment",
  "页面.岗位.管理视角": "Management view",
  "页面.岗位.粘贴编号列表": "Paste job no. list",
  "页面.岗位.经验0到3年": "0-3 years",
  "页面.岗位.经验10年以上": "10+ years",
  "页面.岗位.经验1到3年": "1-3 years",
  "页面.岗位.经验1年以内": "Within 1 year",
  "页面.岗位.经验3到5年": "3-5 years",
  "页面.岗位.经验3年以上": "3+ years",
  "页面.岗位.经验5到10年": "5-10 years",
  "页面.岗位.经验不限": "No limit",
  "页面.岗位.结构化内容": "Structured content",
  "页面.岗位.继续编辑": "Continue editing",
  "页面.岗位.编号列表提示": "Split by comma, space, or new line",
  "页面.岗位.编号区间": "Job no. range",
  "页面.岗位.编号日期": "Job no. date",
  "页面.岗位.编辑岗位": "Edit job",
  "页面.岗位.置顶": "Pin",
  "页面.岗位.翻译": "Translate",
  "页面.岗位.翻译预览": "Translation preview",
  "页面.岗位.职位描述": "Job duties",
  "页面.岗位.联系人": "Contact",
  "页面.岗位.联系人姓名": "Contact name",
  "页面.岗位.联系人电话": "Contact phone",
  "页面.岗位.联系时间": "Contact time",
  "页面.岗位.联系时间说明": "When user viewed contact",
  "页面.岗位.联系电话": "Phone",
  "页面.岗位.联系电话运营商": "Phone operator",
  "页面.岗位.联系电话运营商说明": "Phone operator tag (config-based), for exact filter",
  "页面.岗位.自动创建岗位": "Auto create job",
  "页面.岗位.自动发布岗位": "Auto publish job",
  "页面.岗位.自发布": "User-posted",
  "页面.岗位.英文标签": "English (en_US)",
  "页面.岗位.草稿": "Draft",
  "页面.岗位.获取任务详情失败": "Failed to load task",
  "页面.岗位.获取任务详情失败重试": "Failed to load task, please retry",
  "页面.岗位.获取企业详情失败": "Failed to load company",
  "页面.岗位.获取企业详情失败重试": "Failed to load company, please retry",
  "页面.岗位.获取岗位详情失败": "Failed to load job detail",
  "页面.岗位.获取岗位详情失败重试": "Failed to load job, please retry",
  "页面.岗位.获取批次任务失败": "Failed to load batch",
  "页面.岗位.获取批次任务失败重试": "Failed to load batch, please retry",
  "页面.岗位.获取详情失败": "Failed to load detail",
  "页面.岗位.获取详情失败重试": "Failed to load detail, please retry",
  "页面.岗位.获取链接": "Get link",
  "页面.岗位.薪资": "Salary",
  "页面.岗位.薪资时间单位": "Salary unit",
  "页面.岗位.薪资结算单位": "Settlement unit",
  "页面.岗位.薪资结算单位说明": "Filter by settlement unit",
  "页面.岗位.薪资说明": "Salary range with unit",
  "页面.岗位.薪资面议": "Salary negotiable",
  "页面.岗位.被联系次数": "Contact count",
  "页面.岗位.被联系次数说明": "C-side view count, click for list",
  "页面.岗位.被联系用户": "Contacted users",
  "页面.岗位.被联系用户带标题": "Contacted: {title}",
  "页面.岗位.证书资质": "Certificates",
  "页面.岗位.该岗位不在当前列表条件下": "Job not in current list",
  "页面.岗位.该批次暂无任务": "No tasks in this batch",
  "页面.岗位.该日暂无岗位数据": "No jobs for this date",
  "页面.岗位.详细描述": "Description",
  "页面.岗位.请从列表点击审核打开": "Click Review in list to open",
  "页面.岗位.请先加载列表后再定位": "Load list first to locate",
  "页面.岗位.请先选择一个数据段": "Select a segment from the left first",
  "页面.岗位.请先选择操作分配人": "Select operator assignee first",
  "页面.岗位.请求失败": "Request failed",
  "页面.岗位.请输入任职要求": "Enter requirements",
  "页面.岗位.请输入企业全称": "Enter full company name (2-200 chars)",
  "页面.岗位.请输入最大薪资": "Max salary (step 100)",
  "页面.岗位.请输入最小薪资": "Min salary (step 100)",
  "页面.岗位.请输入完整编号区间": "Enter full job no. range",
  "页面.岗位.请输入审核备注": "Enter remark",
  "页面.岗位.请输入岗位ID或编号": "Enter job ID or job no. (e.g. 20250226-000001)",
  "页面.岗位.请输入岗位名称": "Enter job title",
  "页面.岗位.请输入岗位地址非标地址": "Enter job address (non-standard)",
  "页面.岗位.请输入岗位职责": "Enter job duties",
  "页面.岗位.请输入工作职责": "Enter responsibilities",
  "页面.岗位.请输入工作要求": "Enter work requirements",
  "页面.岗位.请输入技能要求": "Enter skills",
  "页面.岗位.请输入招聘人数": "Enter headcount",
  "页面.岗位.请输入福利待遇": "Enter benefits",
  "页面.岗位.请输入职位描述": "Enter job duties",
  "页面.岗位.请输入联系人姓名": "Enter contact name",
  "页面.岗位.请输入联系电话": "Enter phone",
  "页面.岗位.请输入至少2个字符": "Enter at least 2 characters",
  "页面.岗位.请输入至少一个岗位编号": "Enter at least one job no.",
  "页面.岗位.请输入证书资质": "Enter certificates",
  "页面.岗位.请输入飞机号": "Enter Telegram",
  "页面.岗位.请选择不通过原因": "Select rejection reasons",
  "页面.岗位.请选择分配人": "Select assignee",
  "页面.岗位.请选择学历要求": "Select education",
  "页面.岗位.请选择岗位标签可多选": "Select job tags (multi)",
  "页面.岗位.请选择岗位标签后展示岗位分组配置": "Select job tags to show matching job group configuration",
  "页面.岗位.请选择工作地点": "Select location",
  "页面.岗位.请选择工作性质": "Select employment type",
  "页面.岗位.请选择工作福利标签可多选": "Select lexicon tags (multi): job requirements, benefits, work mode, platform status, etc.",
  "页面.岗位.请选择工作经验要求": "Select experience requirement",
  "页面.岗位.请选择工种": "Select job category",
  "页面.岗位.请选择开始时间": "Select start time",
  "页面.岗位.请选择性别要求": "Select gender requirement",
  "页面.岗位.请选择结束时间": "Select end time",
  "页面.岗位.请选择编号日期": "Select job no. date",
  "页面.岗位.请选择至少一个不通过原因": "Please select at least one rejection reason",
  "页面.岗位.请选择至少一条岗位": "Select at least one job",
  "页面.岗位.请选择薪资时间单位": "Select salary unit",
  "页面.岗位.请选择薪资结算单位": "Select settlement unit",
  "页面.岗位.输入内容": "Input",
  "页面.岗位.运营录入": "Ops entry",
  "页面.岗位.返回上一条": "Back to previous",
  "页面.岗位.返回非成功": "Response not success",
  "页面.岗位.选择一组进行操作": "Select a group to assign or unassign",
  "页面.岗位.选择分配人并确认": "Select assignee and confirm",
  "页面.岗位.选择日期": "Select date",
  "页面.岗位.部分成功部分失败": "Done: {ok} succeeded, {fail} failed",
  "页面.岗位.链接已复制": "Link copied to clipboard",
  "页面.岗位.非结构化企业名称": "Company name (unstructured)",
  "页面.岗位.面谈": "Negotiable",
  "页面.岗位.预览返回异常": "Preview error",
  "页面.岗位.飞机号": "Telegram",
  "页面.岗位.首次提交翻译时间": "First translation at",
  "页面.岗位.高中": "High school",
  "页面.岗位.高棉语标签": "Khmer (km_KH)",
  "页面.岗位分组配置.一级组名称": "Top-level group name",
  "页面.岗位分组配置.一级组集合": "Top-level collection",
  "页面.岗位分组配置.关联工种": "Related job groups",
  "页面.岗位分组配置.关联工种最多5个": "Select no more than 5 related job groups",
  "页面.岗位分组配置.关联工种说明": "Select sub-groups only, up to 5",
  "页面.岗位分组配置.子级组列表": "Sub-group list",
  "页面.岗位分组配置.子级组名称": "Sub-group name",
  "页面.岗位分组配置.子级组集合": "Sub-group collection",
  "页面.岗位分组配置.子级组集合ID": "Sub-group collection ID",
  "页面.岗位分组配置.子级组集合ID不能为空": "Sub-group collection ID is required",
  "页面.岗位分组配置.子级组集合ID不能重复": "Sub-group collection IDs cannot be duplicated",
  "页面.岗位分组配置.子级组集合为空说明": "There are no available tags under the current top-level selection. Please choose top-level tags with descendants.",
  "页面.岗位分组配置.子级组集合只允许来自一级组集合的子集": "Sub-group collection IDs must come from descendants of the selected top-level collections",
  "页面.岗位分组配置.子级集合为空说明": "There are no available tags under the current top-level selection. Please choose top-level tags with descendants.",
  "页面.岗位分组配置.岗位分组配置管理": "Job Group Configuration",
  "页面.岗位分组配置.排序": "Order",
  "页面.岗位分组配置.排序顺序说明": "Smaller number = higher rank",
  "页面.岗位分组配置.数据已同步服务端提示": "Configuration is stored on the server and validated against job-position dictionary tags.",
  "页面.岗位分组配置.新增一级组": "Add top-level group",
  "页面.岗位分组配置.是否热门": "Hot",
  "页面.岗位分组配置.添加子级组": "Add sub-group",
  "页面.岗位分组配置.热门": "Hot",
  "页面.岗位分组配置.热门排序": "Hot order",
  "页面.岗位分组配置.热门排序说明": "Smaller number ranks higher in the hot list only",
  "页面.岗位分组配置.状态": "Status",
  "页面.岗位分组配置.确认删除该配置": "Are you sure you want to delete this job group configuration?",
  "页面.岗位分组配置.编辑一级组": "Edit top-level group",
  "页面.岗位分组配置.请至少添加一个子级组": "Please add at least one sub-group",
  "页面.岗位分组配置.请输入一级组名称": "Enter top-level group name",
  "页面.岗位分组配置.请输入子级组名称": "Enter sub-group name",
  "页面.岗位分组配置.请输入排序": "Please enter order",
  "页面.岗位分组配置.请输入热门排序": "Please enter hot order",
  "页面.岗位分组配置.请选择一级组集合": "Please select top-level collection",
  "页面.岗位分组配置.请选择关联工种": "Select related job groups",
  "页面.岗位分组配置.请选择子级组集合": "Please select sub-group collection",
  "页面.岗位分组配置.请选择子级组集合ID": "Please select sub-group collection ID",
  "页面.岗位分组配置.非热门": "Normal",
  "页面.岗位生成.CamHR": "CamHR",
  "页面.岗位生成.config_category_id": "Category ID",
  "页面.岗位生成.config_category_name": "Category name",
  "页面.岗位生成.config_entity_id": "Entity ID",
  "页面.岗位生成.config_entity_name": "Entity name",
  "页面.岗位生成.Dashboard.一级汇总": "Source summary",
  "页面.岗位生成.Dashboard.不通过原因分布": "Rejection reason breakdown",
  "页面.岗位生成.Dashboard.任务失败率": "Task failure rate",
  "页面.岗位生成.Dashboard.任务失败率说明": "failed / (success + failed), 0 if none",
  "页面.岗位生成.Dashboard.任务完成率": "Task completion rate",
  "页面.岗位生成.Dashboard.任务完成率说明": "(success + failed) / total tasks",
  "页面.岗位生成.Dashboard.任务成功率": "Task success rate",
  "页面.岗位生成.Dashboard.任务成功率说明": "success / (success + failed), 0 if none",
  "页面.岗位生成.Dashboard.任务级未创建原因": "Task-level skip reasons",
  "页面.岗位生成.Dashboard.任务级未创建原因说明": "Reasons when task had no job slots (e.g. content irrelevant, no jobs extracted)",
  "页面.岗位生成.Dashboard.任务维度统计": "Task stats",
  "页面.岗位生成.Dashboard.任务进行中占比": "In-progress task ratio",
  "页面.岗位生成.Dashboard.任务进行中占比说明": "(pending + running) / total tasks",
  "页面.岗位生成.Dashboard.入口名称": "Entity name",
  "页面.岗位生成.Dashboard.入口按钮": "Data dashboard",
  "页面.岗位生成.Dashboard.全部外部": "All external",
  "页面.岗位生成.Dashboard.全量暂无数据": "No data",
  "页面.岗位生成.Dashboard.全量查询等待提示": "Full data query may take a while, please wait…",
  "页面.岗位生成.Dashboard.创建异常条数": "Creation failed items",
  "页面.岗位生成.Dashboard.创建异常条数说明": "Items that failed to create (reason creation_failed)",
  "页面.岗位生成.Dashboard.占比": "Share",
  "页面.岗位生成.Dashboard.场景1": "Single-dimension summary",
  "页面.岗位生成.Dashboard.场景2": "Full by source/entity",
  "页面.岗位生成.Dashboard.实际创建岗位数": "Jobs actually created",
  "页面.岗位生成.Dashboard.实际创建岗位数说明": "Sum of job IDs created per task",
  "页面.岗位生成.Dashboard.审核不通过": "Rejected",
  "页面.岗位生成.Dashboard.审核通过": "Approved",
  "页面.岗位生成.Dashboard.审核通过率": "Approval rate",
  "页面.岗位生成.Dashboard.岗位创建率": "Job creation rate",
  "页面.岗位生成.Dashboard.岗位创建率说明": "jobs created / task count, 0 if no tasks",
  "页面.岗位生成.Dashboard.岗位条创建异常率": "Item creation error rate",
  "页面.岗位生成.Dashboard.岗位条创建异常率说明": "creation_failed / total slots",
  "页面.岗位生成.Dashboard.岗位条创建转化率": "Item-to-job conversion rate",
  "页面.岗位生成.Dashboard.岗位条创建转化率说明": "created / total slots, 0 if no slots",
  "页面.岗位生成.Dashboard.岗位条结果排行": "Item outcome ranking",
  "页面.岗位生成.Dashboard.岗位条维度统计": "Job item stats",
  "页面.岗位生成.Dashboard.已创建岗位审核": "Created jobs review",
  "页面.岗位生成.Dashboard.已创建条数": "Created items",
  "页面.岗位生成.Dashboard.已创建条数说明": "Items that became jobs (reason created)",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数": "Avg jobs per task",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数说明": "total_jd_created / total tasks",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条": "Avg parsed items per task",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条说明": "total slots / total tasks",
  "页面.岗位生成.Dashboard.开始查询": "Query",
  "页面.岗位生成.Dashboard.弹窗标题": "External source · Job generation dashboard",
  "页面.岗位生成.Dashboard.待审": "Pending",
  "页面.岗位生成.Dashboard.总任务数": "Total tasks",
  "页面.岗位生成.Dashboard.总任务数说明": "Total tasks in time range and source",
  "页面.岗位生成.Dashboard.总岗位槽位数": "Total job slots",
  "页面.岗位生成.Dashboard.总岗位槽位数说明": "Sum of job items from all tasks",
  "页面.岗位生成.Dashboard.成功任务中已创建占比": "Share of success tasks with ≥1 job",
  "页面.岗位生成.Dashboard.成功任务中已创建占比说明": "result_type=created tasks / success tasks",
  "页面.岗位生成.Dashboard.成功任务中未创建占比": "Share of success tasks with no job",
  "页面.岗位生成.Dashboard.成功任务中未创建占比说明": "result_type=skipped tasks / success tasks",
  "页面.岗位生成.Dashboard.按数据源分组": "Group by source",
  "页面.岗位生成.Dashboard.按状态分布": "By status",
  "页面.岗位生成.Dashboard.按状态分布说明": "pending / running / success / failed",
  "页面.岗位生成.Dashboard.按结果类型分布": "By result type",
  "页面.岗位生成.Dashboard.按结果类型分布说明": "For finished tasks: created / skipped / failed",
  "页面.岗位生成.Dashboard.数据源池": "Source pool",
  "页面.岗位生成.Dashboard.数据源池说明": "Empty = all; selected = rows for that pool",
  "页面.岗位生成.Dashboard.数据源维度": "Data source",
  "页面.岗位生成.Dashboard.数据源维度说明": "Filter by channel; empty = all external",
  "页面.岗位生成.Dashboard.数据统计时间": "Data computed at",
  "页面.岗位生成.Dashboard.时间区间": "Time range",
  "页面.岗位生成.Dashboard.时间区间说明": "Stats for tasks created in this period",
  "页面.岗位生成.Dashboard.暂无排行数据": "No ranking data",
  "页面.岗位生成.Dashboard.未创建原因细分": "Skip reason breakdown",
  "页面.岗位生成.Dashboard.未创建原因细分说明": "Count per reason code for skipped items",
  "页面.岗位生成.Dashboard.未创建岗位条占比": "Uncreated item ratio",
  "页面.岗位生成.Dashboard.未创建岗位条占比说明": "uncreated items / total slots",
  "页面.岗位生成.Dashboard.未创建岗位条数": "Uncreated items",
  "页面.岗位生成.Dashboard.未创建岗位条数说明": "total slots - created - creation_failed",
  "页面.岗位生成.Dashboard.条入口": " entities",
  "页面.岗位生成.Dashboard.查看看板": "View dashboard",
  "页面.岗位生成.Dashboard.查询条件": "Query conditions",
  "页面.岗位生成.Dashboard.核心概览": "Key overview",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数": "Jobs per completed task",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数说明": "total jobs created / (success + failed)",
  "页面.岗位生成.Dashboard.绝对值": "Count",
  "页面.岗位生成.Dashboard.自定义": "Custom",
  "页面.岗位生成.Dashboard.获取失败": "Failed to load dashboard",
  "页面.岗位生成.Dashboard.请选择时间": "Please select time range",
  "页面.岗位生成.Dashboard.转化率与漏斗": "Conversion & funnel",
  "页面.岗位生成.Dashboard.选择条件": "Select query conditions",
  "页面.岗位生成.Dashboard.页面标题": "Job Data Dashboard",
  "页面.岗位生成.entity_type": "Entity type",
  "页面.岗位生成.entity_url": "Entity URL",
  "页面.岗位生成.Facebook": "Facebook",
  "页面.岗位生成.LLM原始响应": "LLM raw",
  "页面.岗位生成.LLM原始响应说明": "Has LLM raw (debug)",
  "页面.岗位生成.source_label": "Source name",
  "页面.岗位生成.TG": "TG",
  "页面.岗位生成.任务ID说明": "Task ID, click for detail",
  "页面.岗位生成.任务创建时间": "Created at",
  "页面.岗位生成.任务级原因码": "Task-level reason codes",
  "页面.岗位生成.任务队列统计": "Queue stats",
  "页面.岗位生成.全部": "All",
  "页面.岗位生成.全部外部": "All external",
  "页面.岗位生成.全部外部数据源": "All external",
  "页面.岗位生成.其他": "Other",
  "页面.岗位生成.刷新": "Refresh",
  "页面.岗位生成.原因码": "Reason codes",
  "页面.岗位生成.原因码.all_format_validation_failed": "All format validation failed",
  "页面.岗位生成.原因码.all_jd_creation_failed": "All JD creation failed",
  "页面.岗位生成.原因码.content_irrelevant": "Content irrelevant to job",
  "页面.岗位生成.原因码.creation_failed": "Creation failed",
  "页面.岗位生成.原因码.duplicate": "Duplicate job",
  "页面.岗位生成.原因码.format_validation_failed": "Format validation failed",
  "页面.岗位生成.原因码.missing_contact_phone": "Missing contact phone",
  "页面.岗位生成.原因码.missing_location": "Missing location",
  "页面.岗位生成.原因码.missing_title": "Missing title",
  "页面.岗位生成.原因码.no_jobs_extracted": "No jobs extracted",
  "页面.岗位生成.原因码.salary_max_invalid": "Max salary invalid",
  "页面.岗位生成.原因码.salary_min_invalid": "Min salary must be non-negative",
  "页面.岗位生成.原因码.salary_negative": "Salary range cannot be negative",
  "页面.岗位生成.原因码.salary_range_invalid": "Salary range invalid",
  "页面.岗位生成.原因码.salary_type_invalid": "Salary must be numeric",
  "页面.岗位生成.原因码.title_length_invalid": "Title length invalid",
  "页面.岗位生成.原因码.unknown": "Unknown",
  "页面.岗位生成.原因码分组.任务级": "Task-level",
  "页面.岗位生成.原因码分组.单条岗位": "Single job",
  "页面.岗位生成.原因码分组.质量去重": "Quality / Dedup",
  "页面.岗位生成.原因码占位": "e.g. duplicate",
  "页面.岗位生成.后台创建": "Admin created",
  "页面.岗位生成.外部": "External",
  "页面.岗位生成.外部数据源": "External source",
  "页面.岗位生成.外部数据源渠道": "External source",
  "页面.岗位生成.岗位ID说明": "Generated job IDs",
  "页面.岗位生成.岗位明细": "Item details",
  "页面.岗位生成.已创建岗位": "Job created",
  "页面.岗位生成.并发": "Concurrent",
  "页面.岗位生成.开始时间": "Start time",
  "页面.岗位生成.待执行": "Pending",
  "页面.岗位生成.总计": "Total",
  "页面.岗位生成.我创建的": "My created",
  "页面.岗位生成.我创建的说明": "Only my tasks",
  "页面.岗位生成.执行中": "Running",
  "页面.岗位生成.执行失败": "Failed",
  "页面.岗位生成.执行开始时间": "Start time",
  "页面.岗位生成.执行异常": "Error",
  "页面.岗位生成.执行成功": "Success",
  "页面.岗位生成.执行结束时间": "End time",
  "页面.岗位生成.批次ID": "Batch ID",
  "页面.岗位生成.批次ID说明": "Batch ID, click for batch tasks",
  "页面.岗位生成.按任务状态筛选": "Filter by status (multi)",
  "页面.岗位生成.按原因码筛选": "Filter by reason codes (OR)",
  "页面.岗位生成.按数据源筛选": "Filter by data source",
  "页面.岗位生成.按结果类型筛选": "Filter by result type (multi)",
  "页面.岗位生成.数据源": "Data source",
  "页面.岗位生成.数据源信息": "Source info",
  "页面.岗位生成.无": "No",
  "页面.岗位生成.暂无数据": "No data",
  "页面.岗位生成.有": "Yes",
  "页面.岗位生成.未创建不符合": "Skipped",
  "页面.岗位生成.来源": "Source",
  "页面.岗位生成.来源说明": "Task source",
  "页面.岗位生成.槽位": "Slots",
  "页面.岗位生成.状态": "Status",
  "页面.岗位生成.状态说明": "Task status",
  "页面.岗位生成.结束时间": "End time",
  "页面.岗位生成.结果原因": "Result reasons",
  "页面.岗位生成.结果原因说明": "Task/item reason codes",
  "页面.岗位生成.结果类型": "Result type",
  "页面.岗位生成.结果类型说明": "Result type",
  "页面.岗位生成.自动刷新": "Auto refresh",
  "页面.岗位生成.获取队列统计失败": "Failed to load queue stats",
  "页面.岗位生成.请选择数据源": "Select data source",
  "页面.岗位生成.请选择状态": "Select status",
  "页面.岗位生成.请选择结果类型": "Select result type",
  "页面.岗位生成.运营后台": "Admin",
  "页面.岗位生成.错误信息": "Error message",
  "页面.岗位生成.错误信息说明": "Error when failed",
  "页面.岗位生成.队列": "Queue",
  "页面.岗位黑名单.作用字段": "Field",
  "页面.岗位黑名单.保存失败": "Save failed",
  "页面.岗位黑名单.关键词": "Keyword",
  "页面.岗位黑名单.关键词占位": "Search content",
  "页面.岗位黑名单.内容占位": "One phone, one Telegram username, or one company name",
  "页面.岗位黑名单.内容字段说明": "One value per create; exact match after normalization. Split multiple phones/Telegram names/companies into separate rules; do not join with /, |, or spaces. t.me/+ invite links are not supported.",
  "页面.岗位黑名单.创建失败": "Create failed",
  "页面.岗位黑名单.创建成功建议预览": "Created. Preview matches before enabling.",
  "页面.岗位黑名单.删除": "Delete",
  "页面.岗位黑名单.删除失败": "Delete failed",
  "页面.岗位黑名单.删除失败重试": "Delete failed, retry",
  "页面.岗位黑名单.加载中": "Loading…",
  "页面.岗位黑名单.加载配置失败": "Failed to load rule",
  "页面.岗位黑名单.包含已软删岗位": "Include soft-deleted jobs",
  "页面.岗位黑名单.启用": "Enabled",
  "页面.岗位黑名单.启用状态": "Active",
  "页面.岗位黑名单.命中数量": "Matched jobs",
  "页面.岗位黑名单.命中条数": "Reasons",
  "页面.岗位黑名单.命中记录": "Hits",
  "页面.岗位黑名单.填写说明简": "One value per rule; split multiple numbers into multiple rules. Phone may include +/spaces/dashes; Telegram: t.me or @user; t.me/+ invite links are not supported; do not join multiple values with | or /.",
  "页面.岗位黑名单.填写说明链": "How to fill in",
  "页面.岗位黑名单.备注": "Note",
  "页面.岗位黑名单.备注清空说明": "Clear the field and save to remove the note",
  "页面.岗位黑名单.字段.企业名称": "Company name",
  "页面.岗位黑名单.字段.联系电话": "Phone",
  "页面.岗位黑名单.字段.飞机号": "Telegram",
  "页面.岗位黑名单.岗位ID占位": "Exact job ID",
  "页面.岗位黑名单.岗位侧归一化值": "Normalized job value",
  "页面.岗位黑名单.已保存": "Saved",
  "页面.岗位黑名单.已停用": "Off",
  "页面.岗位黑名单.已删除": "Deleted",
  "页面.岗位黑名单.已启用": "On",
  "页面.岗位黑名单.归一化比对值": "Normalized value",
  "页面.岗位黑名单.操作": "Actions",
  "页面.岗位黑名单.新建内容占位": "[Guidelines — enter ONE value to block in this field]\n\n① One value only. Multiple phones / Telegram usernames / company names → create separate rules; do not put several in one field.\n② Phone: +, spaces, dashes OK; do NOT join numbers with / or | (e.g. 014/093).\n③ Telegram: use https://t.me/username or @username; t.me/+ invite links are NOT supported.\n④ Company name: exact match as one string; do NOT join two names with |, /, or spaces.\n⑤ After save, we normalize the job field and compare; must match exactly.",
  "页面.岗位黑名单.新建内容标签附注": "Read the gray hint in the box, then enter one value to block",
  "页面.岗位黑名单.新建配置": "New rule",
  "页面.岗位黑名单.是否立即预览": "Preview match count now?",
  "页面.岗位黑名单.更新失败": "Update failed",
  "页面.岗位黑名单.更新失败重试": "Update failed, retry",
  "页面.岗位黑名单.状态已更新": "Updated",
  "页面.岗位黑名单.确认删除配置": "Delete this rule?",
  "页面.岗位黑名单.示例岗位": "Sample job IDs",
  "页面.岗位黑名单.示例条数": "Sample limit",
  "页面.岗位黑名单.筛选岗位ID": "Job ID",
  "页面.岗位黑名单.编辑": "Edit",
  "页面.岗位黑名单.编辑配置": "Edit rule",
  "页面.岗位黑名单.规则ID": "Rule ID",
  "页面.岗位黑名单.记录ID": "Hit record ID",
  "页面.岗位黑名单.请填写内容": "Enter content",
  "页面.岗位黑名单.配置ID": "Rule ID",
  "页面.岗位黑名单.配置内容": "Content",
  "页面.岗位黑名单.配置列表": "Rules",
  "页面.岗位黑名单.配置原文": "Configured text",
  "页面.岗位黑名单.重新统计": "Refresh",
  "页面.岗位黑名单.页面标题": "Job blacklist",
  "页面.岗位黑名单.预览命中": "Preview matches",
  "页面.岗位黑名单.预览失败": "Preview failed",
  "页面.岗位黑名单.预览失败重试": "Preview failed, retry",
  "页面.工种搜索反馈.匿名ID": "Anonymous ID",
  "页面.工种搜索反馈.处理": "Handle",
  "页面.工种搜索反馈.处理反馈": "Handle feedback",
  "页面.工种搜索反馈.处理成功": "Updated",
  "页面.工种搜索反馈.处理状态": "Handling status",
  "页面.工种搜索反馈.已处理": "Processed",
  "页面.工种搜索反馈.已忽略": "Ignored",
  "页面.工种搜索反馈.平台": "Platform",
  "页面.工种搜索反馈.待处理": "Pending",
  "页面.工种搜索反馈.提交时间": "Submitted at",
  "页面.工种搜索反馈.搜索词": "Search term",
  "页面.工种搜索反馈.操作": "Actions",
  "页面.工种搜索反馈.来源页面": "Source page",
  "页面.工种搜索反馈.状态": "Status",
  "页面.工种搜索反馈.用户ID": "User ID",
  "页面.工种搜索反馈.语言": "Language",
  "页面.工种搜索反馈.运营备注": "Operations note",
  "页面.工种搜索反馈.页面标题": "Job Search Feedback",
  "页面.布局.用户布局标题": "AI-powered next-generation recruitment platform",
  "页面.推送测试.App版本": "App version",
  "页面.推送测试.Facebook不符合条件": "This user cannot currently receive the Facebook test push",
  "页面.推送测试.Facebook仅Push说明": "No Facebook App ID restriction. This only tests notification delivery and opening the app; it does not create dialog-test eligibility or navigate directly to the third-party accounts page.",
  "页面.推送测试.Facebook仅最新设备": "Like the production task, the preview selects only the latest active device.",
  "页面.推送测试.Facebook原因.已迁移": "The Facebook identity has already migrated to the current App ID.",
  "页面.推送测试.Facebook原因.无设备": "The user has no active mobile push device.",
  "页面.推送测试.Facebook原因.无身份": "No active Facebook identity was found, or the user cannot be contacted.",
  "页面.推送测试.Facebook原因.未知": "Eligibility validation did not pass.",
  "页面.推送测试.Facebook完整联调说明": "No Facebook App ID restriction. Sending starts a 24-hour isolated test round for non-legacy identities, enabling the full dialog and login flow without changing the real provider_tenant.",
  "页面.推送测试.Facebook当前Tenant": "Current tenant",
  "页面.推送测试.Facebook正式规则说明": "The production 17:00 task still targets legacy Facebook tenants only. This page is isolated from the production audience and daily limit.",
  "页面.推送测试.Facebook正式资格": "Real legacy eligibility",
  "页面.推送测试.Facebook测试模式": "Test mode",
  "页面.推送测试.Facebook测试模式.仅Push": "Push delivery only",
  "页面.推送测试.Facebook测试模式.完整联调": "Full reauthorization test (recommended)",
  "页面.推送测试.Facebook测试轮次": "Isolated test round / expiry",
  "页面.推送测试.Facebook真实发送提醒": "Preview eligibility first. A real send immediately notifies only the latest active device selected by the preview.",
  "页面.推送测试.Facebook确认发送说明": "The notification will be sent to the user's latest active device and recorded as a separate admin test. It does not consume the daily production limit.",
  "页面.推送测试.Facebook确认发送说明.仅Push": "The notification will be sent to the latest active device without creating a test round. This only verifies delivery and opening the app. If real reauthorization is not required, no dialog or navigation occurs.",
  "页面.推送测试.Facebook确认发送说明.完整联调": "The notification will be sent to the latest active device. For non-legacy users, an isolated test round is started automatically and completing it does not change the real Facebook identity.",
  "页面.推送测试.Facebook符合条件": "This user can receive the Facebook test push",
  "页面.推送测试.Facebook结束轮次": "End test round",
  "页面.推送测试.Facebook结束轮次成功": "The test round has ended.",
  "页面.推送测试.Facebook结束轮次确认": "End the current test round?",
  "页面.推送测试.Facebook身份Tenant": "Identity tenant",
  "页面.推送测试.Facebook运行配置": "Facebook reauthorization runtime configuration",
  "页面.推送测试.Facebook重新授权": "Facebook reauthorization",
  "页面.推送测试.Facebook重置轮次": "Reset test round",
  "页面.推送测试.Facebook重置轮次成功": "The test round was reset. Preview again before sending.",
  "页面.推送测试.Facebook重置轮次确认": "End the existing round and create a new 24-hour test round?",
  "页面.推送测试.仅预览": "Preview only",
  "页面.推送测试.促活策略": "Activation strategies",
  "页面.推送测试.最近注册": "Last registered",
  "页面.推送测试.功能通知": "Functional notifications",
  "页面.推送测试.加载岗位失败": "Failed to load jobs",
  "页面.推送测试.加载选项失败": "Failed to load push options",
  "页面.推送测试.匿名用户": "Anonymous user",
  "页面.推送测试.匿名用户ID": "Anonymous ID",
  "页面.推送测试.参数.企业ID": "Company ID",
  "页面.推送测试.参数.会话ID": "Conversation ID",
  "页面.推送测试.参数.岗位": "Job",
  "页面.推送测试.参数.工作经历ID": "Experience ID",
  "页面.推送测试.参数.工种": "Job category",
  "页面.推送测试.参数.工种名称": "Job category name",
  "页面.推送测试.参数.教育经历ID": "Education ID",
  "页面.推送测试.参数.来源": "Source",
  "页面.推送测试.参数.标签页": "Tab",
  "页面.推送测试.参数.模块": "Resume module",
  "页面.推送测试.参数.简历ID": "Resume ID",
  "页面.推送测试.参数.链接": "URL",
  "页面.推送测试.参数必填": "{name} is required",
  "页面.推送测试.发送到设备": "Send to device",
  "页面.推送测试.发送失败": "Push failed: {success} succeeded, {failed} failed.",
  "页面.推送测试.发送成功": "Push delivery completed",
  "页面.推送测试.可选设置": "Optional settings",
  "页面.推送测试.合同Profile": "Contract profile",
  "页面.推送测试.合同版本": "Contract",
  "页面.推送测试.否": "No",
  "页面.推送测试.岗位数量": "Job count",
  "页面.推送测试.岗位数量说明": "Used by notification templates that mention a job count.",
  "页面.推送测试.已发送": "Sent",
  "页面.推送测试.投递状态.失败": "Failed",
  "页面.推送测试.投递状态.已发送": "Sent",
  "页面.推送测试.投递状态.已跳过": "Skipped",
  "页面.推送测试.投递状态.重复": "Duplicate",
  "页面.推送测试.投递状态.预览": "Preview",
  "页面.推送测试.推送配置": "Push configuration",
  "页面.推送测试.搜索岗位": "Search published jobs",
  "页面.推送测试.支持路由数": "{count} supported routes",
  "页面.推送测试.无需额外参数": "This type needs no additional parameters.",
  "页面.推送测试.是": "Yes",
  "页面.推送测试.暂无结果": "Complete the form to generate a preview",
  "页面.推送测试.未上报": "Not reported",
  "页面.推送测试.标题正文成对": "Title and body must be provided together",
  "页面.推送测试.模板文案说明": "Leave title and body empty to use the selected language template. Custom title and body must be provided together.",
  "页面.推送测试.消息类型": "Message type",
  "页面.推送测试.状态": "Status",
  "页面.推送测试.用户ID": "User ID",
  "页面.推送测试.登录用户": "Registered user",
  "页面.推送测试.目标与内容": "Target and content",
  "页面.推送测试.目标身份": "Target identity",
  "页面.推送测试.真实发送提醒": "Send to device triggers a real notification immediately. Preview first.",
  "页面.推送测试.确认发送": "Send now",
  "页面.推送测试.确认发送标题": "Send this real notification?",
  "页面.推送测试.确认发送说明": "The notification will be sent to every active device for this identity and recorded.",
  "页面.推送测试.结果": "Push result",
  "页面.推送测试.自定义标题": "Custom title",
  "页面.推送测试.自定义正文": "Custom body",
  "页面.推送测试.角标数量": "Badge count",
  "页面.推送测试.设备合同": "Device contract",
  "页面.推送测试.设备统计": "Device summary",
  "页面.推送测试.设备统计值": "{total} total, {success} succeeded, {failed} failed",
  "页面.推送测试.请求失败": "Request failed. Check the configuration and try again.",
  "页面.推送测试.请输入匿名用户ID": "Enter an anonymous ID",
  "页面.推送测试.请输入用户ID": "Enter a user ID",
  "页面.推送测试.请选择参数": "Select or enter {name}",
  "页面.推送测试.请选择消息类型": "Select a message type",
  "页面.推送测试.路由参数": "Business parameters",
  "页面.推送测试.路由已降级": "Route fallback: {requested} → {actual}",
  "页面.推送测试.选择工种": "Select a job category",
  "页面.推送测试.通知ID": "Notification ID",
  "页面.推送测试.通知ID说明": "Used for idempotency. Leave empty to generate automatically.",
  "页面.推送测试.通知语言": "Notification language",
  "页面.推送测试.部分发送失败": "Push partially delivered: {success} succeeded, {failed} failed.",
  "页面.推送测试.页面标题": "Mobile Push Test",
  "页面.推送测试.页面说明": "Preview and send a real mobile notification to a user or anonymous visitor.",
  "页面.推送测试.页面路由": "App routes",
  "页面.推送测试.预览": "Preview",
  "页面.推送测试.预览成功": "Preview generated",
  "页面.查询表格.万": "K",
  "页面.查询表格.上次调度时间": "Last Run",
  "页面.查询表格.基本信息": "Basic Info",
  "页面.查询表格.已选择": "Chosen",
  "页面.查询表格.开始时间": "Start Time",
  "页面.查询表格.批量删除": "Batch Delete",
  "页面.查询表格.批量审批": "Batch Approve",
  "页面.查询表格.描述": "Description",
  "页面.查询表格.操作": "Actions",
  "页面.查询表格.新建": "New",
  "页面.查询表格.新建规则": "New Rule",
  "页面.查询表格.服务调用次数": "Service Calls",
  "页面.查询表格.服务调用次数总计": "Total Calls",
  "页面.查询表格.标题": "Search Table",
  "页面.查询表格.状态": "Status",
  "页面.查询表格.状态.关闭": "Off",
  "页面.查询表格.状态.已上线": "Online",
  "页面.查询表格.状态.异常": "Abnormal",
  "页面.查询表格.状态.运行中": "Running",
  "页面.查询表格.监控对象": "Object",
  "页面.查询表格.规则名称": "Rule Name",
  "页面.查询表格.规则名称必填": "Rule name is required",
  "页面.查询表格.规则名称标签": "Rule Name",
  "页面.查询表格.规则描述占位": "At least 5 chars",
  "页面.查询表格.规则描述必填": "At least 5 chars for desc!",
  "页面.查询表格.规则描述标签": "Rule Desc",
  "页面.查询表格.规则模板": "Template",
  "页面.查询表格.规则类型": "Type",
  "页面.查询表格.规则配置": "Rule Config",
  "页面.查询表格.订阅警报": "Subscribe",
  "页面.查询表格.设定调度周期": "Schedule",
  "页面.查询表格.请输入异常原因": "Please enter reason!",
  "页面.查询表格.请输入规则名称": "Please enter rule name!",
  "页面.查询表格.请选择开始时间": "Please select start time!",
  "页面.查询表格.配置": "Config",
  "页面.查询表格.配置规则属性": "Rule Props",
  "页面.查询表格.项": "items",
  "页面.欢迎.主标题": "Welcome to DodoJob Admin",
  "页面.欢迎.了解antd": "About Ant Design",
  "页面.欢迎.了解antd描述": "antd is a React UI library based on Ant Design, for enterprise back-office products.",
  "页面.欢迎.了解Pro": "About Pro Components",
  "页面.欢迎.了解Pro描述": "ProComponents provides higher-level template components based on Ant Design.",
  "页面.欢迎.了解umi": "About umi",
  "页面.欢迎.了解umi描述": "umi is an extensible enterprise-level frontend application framework based on routing.",
  "页面.欢迎.了解更多": "Learn more",
  "页面.欢迎.副标题": "DodoJob admin built with Umi + React + Ant Design Pro, providing efficient management tools.",
  "页面.欢迎.重型组件提示": "Faster and stronger heavy-duty components have been released.",
  "页面.求职用户.3到64字符唯一": "3-64 chars, unique",
  "页面.求职用户.上传时间": "Uploaded at",
  "页面.求职用户.专业": "Major",
  "页面.求职用户.个人基础信息": "Personal info",
  "页面.求职用户.中文": "Chinese",
  "页面.求职用户.中文能力": "Chinese ≥",
  "页面.求职用户.会员有效期": "Legacy membership period",
  "页面.求职用户.会员有效期说明": "Used only for legacy quota compatibility. New items use their entitlement batch expiry.",
  "页面.求职用户.会员权益": "Membership",
  "页面.求职用户.会员权益更新成功": "Membership updated",
  "页面.求职用户.会员权益配置说明": "Only B users can be configured. Publishing consumes an item; deleting a job does not return it.",
  "页面.求职用户.保存会员权益失败": "Failed to save membership, please retry",
  "页面.求职用户.全部": "All",
  "页面.求职用户.全部简历": "All resumes",
  "页面.求职用户.公司": "Company",
  "页面.求职用户.公开状态": "Publish status",
  "页面.求职用户.公开状态说明": "draft / private / published",
  "页面.求职用户.公海未关联": "Pool (unassigned)",
  "页面.求职用户.公海池": "Pool",
  "页面.求职用户.关键词": "Keyword",
  "页面.求职用户.关键词搜索": "Keyword",
  "页面.求职用户.关键词说明": "Name, intro, skills, experience",
  "页面.求职用户.内容摘要说明": "Gender, name, age, education, first job; hover for JSON",
  "页面.求职用户.内容范围": "Content scope",
  "页面.求职用户.内容范围说明": "Draft / Published / All",
  "页面.求职用户.出生年月": "Birth date",
  "页面.求职用户.创建": "Create",
  "页面.求职用户.创建失败": "Create failed",
  "页面.求职用户.创建开始时间": "Created from",
  "页面.求职用户.创建成功": "Created successfully",
  "页面.求职用户.创建时间": "Created at",
  "页面.求职用户.创建时间标签": "Created at",
  "页面.求职用户.创建时间说明": "Created at, hover for raw",
  "页面.求职用户.创建用户": "Create user",
  "页面.求职用户.创建结束时间": "Created to",
  "页面.求职用户.加载会员权益失败": "Failed to load membership, please retry",
  "页面.求职用户.加载求职意向详情": "Loading intention detail...",
  "页面.求职用户.加载用户详情": "Loading user detail...",
  "页面.求职用户.加载简历详情": "Loading resume detail...",
  "页面.求职用户.原因": "Reason",
  "页面.求职用户.发岗上限": "Job posting limit",
  "页面.求职用户.发岗上限不能小于已发岗数": "Job posting limit cannot be below the {count} jobs already created",
  "页面.求职用户.发岗上限说明": "Lifetime job creation limit for this account; it cannot be below jobs already created",
  "页面.求职用户.发布内容": "Published content",
  "页面.求职用户.发送岗位加急道具": "Send job boost item",
  "页面.求职用户.发送岗位加急道具失败": "Failed to send. Try again.",
  "页面.求职用户.发送岗位加急道具成功": "Job boost item sent",
  "页面.求职用户.发送岗位加急道具确认": "Send 1 job boost item to {username}? Valid for 30 days.",
  "页面.求职用户.发送岗位发布道具": "Send job posting item",
  "页面.求职用户.发送岗位发布道具失败": "Failed to send. Try again.",
  "页面.求职用户.发送岗位发布道具成功": "Job posting item sent",
  "页面.求职用户.发送岗位发布道具确认": "Send 1 job posting item to {username}? Valid for 30 days.",
  "页面.求职用户.发送简历联系道具": "Send resume contact item",
  "页面.求职用户.发送简历联系道具失败": "Failed to send. Try again.",
  "页面.求职用户.发送简历联系道具成功": "Resume contact item sent",
  "页面.求职用户.发送简历联系道具确认": "Send 1 resume contact item to {username}? Valid for 30 days.",
  "页面.求职用户.只搜发布": "Published only",
  "页面.求职用户.只搜草稿": "Draft only",
  "页面.求职用户.基本信息": "Basic info",
  "页面.求职用户.头像": "Avatar",
  "页面.求职用户.女": "Female",
  "页面.求职用户.姓名": "Name",
  "页面.求职用户.姓名说明": "Match personal_info.name",
  "页面.求职用户.学历": "Education",
  "页面.求职用户.学历说明": "Any education_level",
  "页面.求职用户.学校": "School",
  "页面.求职用户.审核时间": "Reviewed at",
  "页面.求职用户.审核来源": "Review source",
  "页面.求职用户.审核状态": "Review status",
  "页面.求职用户.密码": "Password",
  "页面.求职用户.密码至少8字符": "Password at least 8 characters",
  "页面.求职用户.密码需包含字母和数字": "Include both letters and numbers",
  "页面.求职用户.岁": " years",
  "页面.求职用户.岗位加急道具": "Job boost item",
  "页面.求职用户.岗位加急道具余额": "Available: {count}",
  "页面.求职用户.岗位加急道具说明": "Each confirmation sends 1 item valid for 30 days. See the entitlement ledger for the record.",
  "页面.求职用户.岗位发布道具": "Job posting item",
  "页面.求职用户.岗位发布道具余额": "Available: {count}",
  "页面.求职用户.岗位发布道具说明": "Each confirmation sends 1 item valid for 30 days. See the entitlement ledger for the record.",
  "页面.求职用户.工作内容": "Description",
  "页面.求职用户.工作经历": "Work experience",
  "页面.求职用户.已下架": "Unpublished",
  "页面.求职用户.已关联用户": "Assigned",
  "页面.求职用户.已发布": "Published",
  "页面.求职用户.已封禁": "Blocked",
  "页面.求职用户.已选用户": "Selected users",
  "页面.求职用户.已选用户数量": "{count}",
  "页面.求职用户.已通过": "Approved",
  "页面.求职用户.已驳回": "Rejected",
  "页面.求职用户.待审核": "Pending",
  "页面.求职用户.性别": "Gender",
  "页面.求职用户.意向ID": "Intention ID",
  "页面.求职用户.意向ID标签": "Intention ID",
  "页面.求职用户.意向ID说明": "Intention ID, click for detail",
  "页面.求职用户.手机号": "Phone",
  "页面.求职用户.批量减少道具": "Batch deduct items",
  "页面.求职用户.批量发放道具原因": "Batch item grant from admin",
  "页面.求职用户.批量处理成功": "Processed {count} users",
  "页面.求职用户.批量处理部分失败": "{successCount} succeeded, {failedCount} failed",
  "页面.求职用户.批量扣减道具原因": "Batch item deduction from admin",
  "页面.求职用户.批量添加道具": "Batch add items",
  "页面.求职用户.批量调整道具失败": "Batch adjustment failed. Try again.",
  "页面.求职用户.招聘者": "Employer",
  "页面.求职用户.括号无": "(none)",
  "页面.求职用户.搜索用户名昵称邮箱手机号": "Search username, nickname, email, phone",
  "页面.求职用户.操作": "Actions",
  "页面.求职用户.教育经历": "Education",
  "页面.求职用户.数量": "Quantity",
  "页面.求职用户.文件名": "Filename",
  "页面.求职用户.文件大小": "File size",
  "页面.求职用户.文件无法读取": "Unreadable file",
  "页面.求职用户.无关键信息": "No key info",
  "页面.求职用户.时间": "Period",
  "页面.求职用户.昵称": "Nickname",
  "页面.求职用户.暂无数据": "No data",
  "页面.求职用户.更新时间": "Updated at",
  "页面.求职用户.更新时间标签": "Updated at",
  "页面.求职用户.更新时间说明": "Updated at, hover for raw",
  "页面.求职用户.期望地点": "Expected location",
  "页面.求职用户.期望地点标签": "Expected location",
  "页面.求职用户.期望地点说明": "Exact match location",
  "页面.求职用户.期望岗位": "Expected positions",
  "页面.求职用户.期望岗位标签": "Expected positions",
  "页面.求职用户.期望薪资上限": "Max salary (≤)",
  "页面.求职用户.期望薪资上限说明": "Filter max salary <= value",
  "页面.求职用户.期望薪资下限": "Min salary (≥)",
  "页面.求职用户.期望薪资下限说明": "Filter min salary >= value",
  "页面.求职用户.期望薪资美元": "Expected salary (USD)",
  "页面.求职用户.期望薪资美元标签": "Expected salary (USD)",
  "页面.求职用户.期望薪资范围": "Salary range",
  "页面.求职用户.未提供jobIntentionId或jobIntention": "jobIntentionId or jobIntention not provided",
  "页面.求职用户.未提供resumeId或resume": "resumeId or resume not provided",
  "页面.求职用户.未提供userId或user": "userId or user not provided",
  "页面.求职用户.未激活": "Inactive",
  "页面.求职用户.来源文件": "Source file",
  "页面.求职用户.柬文": "Khmer",
  "页面.求职用户.柬文能力": "Khmer ≥",
  "页面.求职用户.核心技能": "Core skills",
  "页面.求职用户.核心技能说明": "Comma-separated, match any",
  "页面.求职用户.求职岗位列表": "Job positions",
  "页面.求职用户.求职岗位筛选": "Filter by position",
  "页面.求职用户.求职意向": "Job intentions",
  "页面.求职用户.求职意向信息": "Job intention info",
  "页面.求职用户.求职意向详情": "Intention detail",
  "页面.求职用户.求职档案": "Job seeker profile",
  "页面.求职用户.求职者": "Job seeker",
  "页面.求职用户.注册方式": "Signup method",
  "页面.求职用户.注册方式BotStart": "Bot /start",
  "页面.求职用户.注册方式GoogleOAuth": "Google sign-in",
  "页面.求职用户.注册方式TelegramOAuth": "Telegram sign-in",
  "页面.求职用户.注册方式后台创建": "Admin created",
  "页面.求职用户.注册方式后台手动": "Admin manual",
  "页面.求职用户.注册方式小程序授权": "Miniapp auth",
  "页面.求职用户.注册方式说明": "How signed up: miniapp_auth / google_oauth / telegram_oauth / admin / admin_manual / telegram_bot_start (legacy may be empty)",
  "页面.求职用户.注册端App": "App",
  "页面.求职用户.注册端TelegramBot": "Telegram Bot",
  "页面.求职用户.注册端Telegram小程序": "Telegram Mini App",
  "页面.求职用户.注册端管理后台": "Admin console",
  "页面.求职用户.注册端类型": "Signup client",
  "页面.求职用户.注册端类型说明": "Client at signup: app / tg-miniapp / admin / telegram_bot (legacy may be empty)",
  "页面.求职用户.活跃": "Active",
  "页面.求职用户.状态": "Status",
  "页面.求职用户.状态说明": "active / inactive / blocked",
  "页面.求职用户.用户ID": "User ID",
  "页面.求职用户.用户ID标签": "User ID",
  "页面.求职用户.用户ID点击详情": "User ID, click for detail",
  "页面.求职用户.用户ID过滤": "Filter by user ID",
  "页面.求职用户.用户ID过滤公海": "User ID, click for user detail",
  "页面.求职用户.用户名": "Username",
  "页面.求职用户.用户名3到64字符": "Username 3-64 characters",
  "页面.求职用户.用户管理": "User management",
  "页面.求职用户.用户详情": "User detail",
  "页面.求职用户.用户身份说明": "seeker / employer",
  "页面.求职用户.电话": "Phone",
  "页面.求职用户.男": "Male",
  "页面.求职用户.确认发送": "Send",
  "页面.求职用户.确认通过附件": "Approve this resume file?",
  "页面.求职用户.确认驳回附件": "Reject this resume file?",
  "页面.求职用户.空": "(empty)",
  "页面.求职用户.简历ID": "Resume ID",
  "页面.求职用户.简历ID标签": "Resume ID",
  "页面.求职用户.简历ID点击详情": "Resume ID, click for detail",
  "页面.求职用户.简历ID说明": "Resume ID, click for detail",
  "页面.求职用户.简历管理": "Resume management",
  "页面.求职用户.简历联系道具": "Resume contact item",
  "页面.求职用户.简历联系道具余额": "Available: {count}",
  "页面.求职用户.简历联系道具说明": "Each confirmation sends 1 item valid for 30 days. See the entitlement ledger for the record.",
  "页面.求职用户.简历详情": "Resume detail",
  "页面.求职用户.简历附件审核": "Resume file review",
  "页面.求职用户.累计已发岗数": "Lifetime jobs created: {count}",
  "页面.求职用户.累计已发岗数说明": "Includes deleted jobs; deleting a job does not restore posting quota",
  "页面.求职用户.编辑会员权益标题": "Edit {username}'s membership",
  "页面.求职用户.美元": "USD",
  "页面.求职用户.职位": "Position",
  "页面.求职用户.联系次数": "Contact count",
  "页面.求职用户.联系次数说明": "Number of resumes the B user can contact in the talent pool; minimum 0",
  "页面.求职用户.能力说明": "0-4",
  "页面.求职用户.自我介绍": "Self intro",
  "页面.求职用户.自我介绍说明": "Fuzzy match",
  "页面.求职用户.至今": "Present",
  "页面.求职用户.至少8个字符": "At least 8 characters",
  "页面.求职用户.英文": "English",
  "页面.求职用户.英文能力": "English ≥",
  "页面.求职用户.草稿": "Draft",
  "页面.求职用户.草稿内容": "Draft content",
  "页面.求职用户.获取详情失败": "Failed to load detail",
  "页面.求职用户.证书": "Certificates",
  "页面.求职用户.证书名称": "Certificate name",
  "页面.求职用户.证书图片": "Certificate image",
  "页面.求职用户.该简历暂无发布内容": "No published content",
  "页面.求职用户.该简历暂无草稿内容": "No draft content",
  "页面.求职用户.语言等级商务": "Business",
  "页面.求职用户.语言等级基础": "Basic",
  "页面.求职用户.语言等级无": "None",
  "页面.求职用户.语言等级日常": "Daily",
  "页面.求职用户.语言等级母语": "Native",
  "页面.求职用户.语言能力": "Language",
  "页面.求职用户.请求失败": "Request failed",
  "页面.求职用户.请输入原因": "Enter reason",
  "页面.求职用户.请输入发岗上限": "Enter the job posting limit",
  "页面.求职用户.请输入密码": "Please enter password",
  "页面.求职用户.请输入数量": "Enter quantity",
  "页面.求职用户.请输入用户名": "Please enter username",
  "页面.求职用户.请输入联系次数": "Enter the contact count",
  "页面.求职用户.请选择会员有效期": "Select the membership period",
  "页面.求职用户.请选择地区": "Select location",
  "页面.求职用户.请选择岗位可多选": "Select positions (multi)",
  "页面.求职用户.请选择道具类型": "Select an item type",
  "页面.求职用户.账号信息": "Account info",
  "页面.求职用户.账号手机号": "Account phone",
  "页面.求职用户.账号邮箱": "Account email",
  "页面.求职用户.账号限制.封禁": "Ban",
  "页面.求职用户.账号限制.封禁成功": "User banned",
  "页面.求职用户.账号限制.已封禁": "Banned",
  "页面.求职用户.账号限制.已禁言": "Muted",
  "页面.求职用户.账号限制.操作失败": "Action failed, please retry",
  "页面.求职用户.账号限制.正常": "Normal",
  "页面.求职用户.账号限制.状态": "Restriction",
  "页面.求职用户.账号限制.状态说明": "Current mute or account ban status",
  "页面.求职用户.账号限制.确认封禁": "Ban this user?",
  "页面.求职用户.账号限制.确认封禁说明": "The user cannot access signed-in App APIs, but can still submit an appeal.",
  "页面.求职用户.账号限制.确认禁言": "Mute this user?",
  "页面.求职用户.账号限制.确认禁言说明": "The user can still sign in but cannot send IM messages.",
  "页面.求职用户.账号限制.确认解除": "Lift the current restriction?",
  "页面.求职用户.账号限制.禁言": "Mute",
  "页面.求职用户.账号限制.禁言成功": "User muted",
  "页面.求职用户.账号限制.解除": "Lift",
  "页面.求职用户.账号限制.解除成功": "Restriction lifted",
  "页面.求职用户.身份": "Identity",
  "页面.求职用户.身份筛选": "Identity filter",
  "页面.求职用户.选填最大128字符": "Optional, max 128 chars",
  "页面.求职用户.选填唯一": "Optional, unique",
  "页面.求职用户.通过审核": "Approve",
  "页面.求职用户.道具类型": "Item type",
  "页面.求职用户.邮箱": "Email",
  "页面.求职用户.附件ID": "File ID",
  "页面.求职用户.附件审核失败": "Review failed. Try again.",
  "页面.求职用户.附件审核成功": "Review updated",
  "页面.求职用户.附件预览失败": "Preview failed. Try again.",
  "页面.求职用户.非简历文件": "Not a resume",
  "页面.求职用户.颁发日期": "Issue date",
  "页面.求职用户.颁发机构": "Issuer",
  "页面.求职用户.预览附件": "Preview",
  "页面.求职用户.驳回原因": "Rejection reason",
  "页面.求职用户.驳回附件": "Reject",
  "页面.求职用户.默认求职者": "Default job seeker",
  "页面.热门分组配置.上传配图提示": "Upload tag image",
  "页面.热门分组配置.岗位标签集": "Job tags collection",
  "页面.热门分组配置.岗位标签集支持说明": "Level 1 is only for grouping. Select level-2 items only.",
  "页面.热门分组配置.拖拽调整展示顺序": "Drag to reorder",
  "页面.热门分组配置.排序": "Order",
  "页面.热门分组配置.新增标签": "Add tag",
  "页面.热门分组配置.标签名称": "Tag name",
  "页面.热门分组配置.正在更新": "Updating...",
  "页面.热门分组配置.正在更新排序": "Updating order",
  "页面.热门分组配置.状态": "Status",
  "页面.热门分组配置.确认删除该标签": "Are you sure you want to delete this tag?",
  "页面.热门分组配置.编辑标签": "Edit tag",
  "页面.热门分组配置.请输入排序": "Please enter order",
  "页面.热门分组配置.请输入标签名称": "Please enter tag name",
  "页面.热门分组配置.请选择岗位标签集": "Please select job tags collection",
  "页面.热门分组配置.配图": "Image",
  "页面.登录.失败": "Login failed, please retry.",
  "页面.登录.密码占位": "Password",
  "页面.登录.密码必填": "Please enter password!",
  "页面.登录.忘记密码": "Forgot password",
  "页面.登录.成功": "Login successful!",
  "页面.登录.提交": "Login",
  "页面.登录.用户名占位": "Username",
  "页面.登录.用户名必填": "Please enter username!",
  "页面.登录.自动登录": "Remember me",
  "页面.登录.账户或密码错误": "Invalid username or password",
  "页面.登录.账户登录": "Account Login",
  "页面.管理.仅管理员可看": "This page can only be viewed by admin",
  "页面.管理.使用区块": "use block",
  "页面.管理.标题": "DodoJob Admin",
  "页面.管理.添加页面提示": "Want to add more pages? Please refer to",
  "页面.配置.地区.Tab标准": "Standard locations",
  "页面.配置.地区.Tab非标": "Non-standard locations",
  "页面.配置.地区.上移": "Move up",
  "页面.配置.地区.下移": "Move down",
  "页面.配置.地区.仅一二级可设热门": "Only level 1 or 2 can be hot/sorted",
  "页面.配置.地区.仅一二级可设热门提示": "Only level 1 or 2",
  "页面.配置.地区.可选一级或二级": "Select level 1 or 2",
  "页面.配置.地区.同步": "Sync",
  "页面.配置.地区.同步成功条": "Synced {count} locations",
  "页面.配置.地区.否": "No",
  "页面.配置.地区.启用国家": "Enable country",
  "页面.配置.地区.启用国家同步后可启用": "Enable country (after sync)",
  "页面.配置.地区.启用失败": "Enable failed",
  "页面.配置.地区.启用失败重试": "Enable failed, please retry",
  "页面.配置.地区.启用成功": "Enabled",
  "页面.配置.地区.地区排序说明": "{count} locations. Move up/down changes sibling order. The C-end location tree and hot locations use this order.",
  "页面.配置.地区.地区树": "Location tree",
  "页面.配置.地区.多语言名称": "Display names",
  "页面.配置.地区.展示排序": "Display order",
  "页面.配置.地区.展示排序提示": "Smaller number = higher rank. Applies to all and hot locations.",
  "页面.配置.地区.已启用": "Enabled",
  "页面.配置.地区.已在热门列表中": "Already in hot list",
  "页面.配置.地区.当前仅支持同步柬埔寨": "Only Cambodia (KH) sync supported",
  "页面.配置.地区.当前仅支持启用柬埔寨": "Only Cambodia (KH) can be enabled",
  "页面.配置.地区.排序": "Order",
  "页面.配置.地区.是": "Yes",
  "页面.配置.地区.是否启用": "Active",
  "页面.配置.地区.显示名称": "Display name",
  "页面.配置.地区.显示名称说明": "Display: zh_CN → en_US → name_en",
  "页面.配置.地区.暂无可排序地区": "No locations to sort",
  "页面.配置.地区.暂无可用国家": "No countries available. Check backend config.",
  "页面.配置.地区.暂无热门地区": "No hot locations. Add from the selector above.",
  "页面.配置.地区.标准名称": "Standard name",
  "页面.配置.地区.标准名称说明": "English name from data, read-only",
  "页面.配置.地区.添加": "Add",
  "页面.配置.地区.热门": "Hot",
  "页面.配置.地区.热门排序": "Hot order",
  "页面.配置.地区.热门排序提示": "Smaller number = higher rank",
  "页面.配置.地区.热门顺序说明": "Order = hot display order and shared location order. Move up/down to adjust. Empty list clears all hot items.",
  "页面.配置.地区.移除": "Remove",
  "页面.配置.地区.管理地区排序": "Manage location order",
  "页面.配置.地区.管理热门城市": "Manage hot cities",
  "页面.配置.地区.级别": "Level",
  "页面.配置.地区.编码": "Code",
  "页面.配置.地区.编辑地区": "Edit location",
  "页面.配置.地区.自动生成多语言": "Auto generate",
  "页面.配置.地区.该国家尚未同步": "This country has not been synced. Click Sync to load location data.",
  "页面.配置.地区.请填写不小于0的整数": "Enter integer ≥ 0",
  "页面.配置.地区.请输入名称": "Enter {label} name",
  "页面.配置.岗位反馈类型.创建时间": "Created at",
  "页面.配置.岗位反馈类型.创建时间说明": "Created at, hover for raw",
  "页面.配置.岗位反馈类型.名称说明": "Name (value)",
  "页面.配置.岗位反馈类型.岗位反馈类型ID": "Job feedback type ID",
  "页面.配置.岗位反馈类型.岗位反馈类型管理": "Job Feedback Types",
  "页面.配置.岗位反馈类型.成功删除N个": "Deleted {n} job feedback types",
  "页面.配置.岗位反馈类型.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.配置.岗位反馈类型.排序": "Order",
  "页面.配置.岗位反馈类型.排序说明": "Smaller = higher rank",
  "页面.配置.岗位反馈类型.是否启用": "Active",
  "页面.配置.岗位反馈类型.正在删除N个": "Deleting {n} job feedback types...",
  "页面.配置.岗位反馈类型.正在更新": "Updating...",
  "页面.配置.岗位反馈类型.正在添加": "Adding...",
  "页面.配置.岗位反馈类型.确定删除岗位反馈类型": "Delete this job feedback type?",
  "页面.配置.岗位投诉类型.创建时间": "Created at",
  "页面.配置.岗位投诉类型.创建时间说明": "Created at, hover for raw",
  "页面.配置.岗位投诉类型.名称说明": "Name (value)",
  "页面.配置.岗位投诉类型.岗位投诉类型ID": "Complaint type ID",
  "页面.配置.岗位投诉类型.岗位投诉类型管理": "Complaint Types",
  "页面.配置.岗位投诉类型.成功删除N个": "Deleted {n} complaint types",
  "页面.配置.岗位投诉类型.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.配置.岗位投诉类型.排序": "Order",
  "页面.配置.岗位投诉类型.排序说明": "Smaller = higher rank",
  "页面.配置.岗位投诉类型.是否启用": "Active",
  "页面.配置.岗位投诉类型.正在删除N个": "Deleting {n} complaint types...",
  "页面.配置.岗位投诉类型.正在更新": "Updating...",
  "页面.配置.岗位投诉类型.正在添加": "Adding...",
  "页面.配置.岗位投诉类型.确定删除岗位投诉类型": "Delete this complaint type?",
  "页面.配置.岗位标签.Tab标准": "Standard job positions",
  "页面.配置.岗位标签.Tab非标": "Non-standard job tags",
  "页面.配置.岗位标签.多语言显示文本": "Display text (i18n)",
  "页面.配置.岗位标签.多语言显示文本说明": "Optional for i18n. Fill or auto-generate",
  "页面.配置.岗位标签.导出全量": "Export all",
  "页面.配置.岗位标签.导出密码": "Password",
  "页面.配置.岗位标签.导出成功": "Export succeeded",
  "页面.配置.岗位标签.导出标准岗位标签全量": "Export standard job positions (full)",
  "页面.配置.岗位标签.导出用户名": "Username",
  "页面.配置.岗位标签.导出非标岗位标签全量": "Export non-standard job tags (full)",
  "页面.配置.岗位标签.岗位数": "Job count",
  "页面.配置.岗位标签.岗位数说明": "Number of jobs using this tag",
  "页面.配置.岗位标签.岗位标签管理": "Job Positions",
  "页面.配置.岗位标签.成功删除N个": "Deleted {n} job positions",
  "页面.配置.岗位标签.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.配置.岗位标签.按原始文本关键词搜索": "Enter keyword to search",
  "页面.配置.岗位标签.新建岗位标签": "New job position",
  "页面.配置.岗位标签.新建标签": "New label",
  "页面.配置.岗位标签.是否启用": "Active",
  "页面.配置.岗位标签.标签ID": "Label ID",
  "页面.配置.岗位标签.标签代码": "Code",
  "页面.配置.岗位标签.标签名称": "Label name",
  "页面.配置.岗位标签.标签名称value": "Label (value)",
  "页面.配置.岗位标签.标签名称不能超过128": "Label name max 128 characters",
  "页面.配置.岗位标签.标签名称多语言": "Label name (i18n)",
  "页面.配置.岗位标签.标签名称必填": "Label name is required",
  "页面.配置.岗位标签.标签配图": "Tag image",
  "页面.配置.岗位标签.标签配图tips": "Crop 1:1 first; system then generates 1x (88×88) and 2x (176×176) and uploads both. For best quality, use an image at least 176×176; after crop, shortest side ≥176px.",
  "页面.配置.岗位标签.正在删除N个": "Deleting {n} job positions...",
  "页面.配置.岗位标签.正在更新": "Updating...",
  "页面.配置.岗位标签.正在添加": "Adding...",
  "页面.配置.岗位标签.添加子级": "Add child",
  "页面.配置.岗位标签.确定删除岗位标签": "Delete this job position? Children will be deleted too.",
  "页面.配置.岗位标签.编辑岗位标签": "Edit job position",
  "页面.配置.岗位标签.至少填写一个语言": "At least one language required",
  "页面.配置.岗位标签.至少填写中文或英文": "At least Chinese or English required",
  "页面.配置.岗位标签.请输入导出密码": "Enter password",
  "页面.配置.岗位标签.请输入导出用户名": "Enter username",
  "页面.配置.岗位标签.请输入标签名称": "e.g. Software Engineer",
  "页面.配置.岗位标签.选择图片并裁剪": "Select image and crop 1:1",
  "页面.配置.岗位标签.配图": "Image",
  "页面.配置.岗位标签.配图尺寸过小": "After crop, the shortest side must be at least {min}px (current {current}px). Use a larger image or zoom out.",
  "页面.配置.岗位标签.配图规格说明": "1x {w1}×{h1}px, 2x {w2}×{h2}px, crop then upload",
  "页面.配置.岗位标签.非标出现次数": "Occurrence count",
  "页面.配置.岗位标签.非标出现次数说明": "For analysis and sorting",
  "页面.配置.岗位标签.非标原始文本": "Raw text",
  "页面.配置.岗位标签.非标原始文本说明": "Raw text when no standard tag matched",
  "页面.配置.岗位标签.非标类型": "Type",
  "页面.配置.岗位标签.非标类型岗位标签": "Job position tag",
  "页面.配置.岗位标签.非标类型工作地点": "Location",
  "页面.配置.游客联系限制.中度不能小于轻度": "Medium threshold cannot be lower than light threshold",
  "页面.配置.游客联系限制.中度联系": "Medium contact",
  "页面.配置.游客联系限制.中度联系阈值": "Medium contact threshold",
  "页面.配置.游客联系限制.加载失败": "Failed to load config",
  "页面.配置.游客联系限制.加载失败重试": "Failed to load config, please retry",
  "页面.配置.游客联系限制.周": "week",
  "页面.配置.游客联系限制.周期单位": "Window unit",
  "页面.配置.游客联系限制.周期数值": "Window value",
  "页面.配置.游客联系限制.天": "day",
  "页面.配置.游客联系限制.当前生效配置": "Active Config",
  "页面.配置.游客联系限制.月": "month",
  "页面.配置.游客联系限制.次": "times",
  "页面.配置.游客联系限制.正在保存": "Saving config...",
  "页面.配置.游客联系限制.统计周期": "Counting Window",
  "页面.配置.游客联系限制.说明内容": "The C-end reads this from /api/v1/config to classify visitor job-contact counts within the configured window.",
  "页面.配置.游客联系限制.说明标题": "C-end contract",
  "页面.配置.游客联系限制.请输入中度阈值": "Enter the medium contact threshold",
  "页面.配置.游客联系限制.请输入周期数值": "Enter the window value",
  "页面.配置.游客联系限制.请输入轻度阈值": "Enter the light contact threshold",
  "页面.配置.游客联系限制.请选择周期单位": "Select the window unit",
  "页面.配置.游客联系限制.轻度联系": "Light contact",
  "页面.配置.游客联系限制.轻度联系阈值": "Light contact threshold",
  "页面.配置.游客联系限制.重新加载": "Reload",
  "页面.配置.游客联系限制.页面标题": "Visitor Contact Limit",
  "页面.配置.游客联系限制.频次限制": "Frequency window",
  "页面.配置.热搜词配置.创建时间": "Created at",
  "页面.配置.热搜词配置.创建时间说明": "Created at, hover for raw",
  "页面.配置.热搜词配置.成功删除N个": "Deleted {n} hot search words",
  "页面.配置.热搜词配置.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.配置.热搜词配置.排序": "Order",
  "页面.配置.热搜词配置.排序说明": "Smaller = higher rank",
  "页面.配置.热搜词配置.新建按钮": "New Hot Search Word",
  "页面.配置.热搜词配置.新建标题": "New Hot Search Word",
  "页面.配置.热搜词配置.是否启用": "Active",
  "页面.配置.热搜词配置.正在删除N个": "Deleting {n} hot search words...",
  "页面.配置.热搜词配置.正在更新": "Updating...",
  "页面.配置.热搜词配置.正在添加": "Adding...",
  "页面.配置.热搜词配置.热搜词": "Hot search word",
  "页面.配置.热搜词配置.热搜词ID": "Hot search word ID",
  "页面.配置.热搜词配置.热搜词说明": "Dictionary value, saved with type=hot_search",
  "页面.配置.热搜词配置.确定删除热搜词": "Delete this hot search word?",
  "页面.配置.热搜词配置.编辑标题": "Edit Hot Search Word",
  "页面.配置.热搜词配置.请输入热搜词": "Enter a hot search word",
  "页面.配置.热搜词配置.页面标题": "Hot Search Words",
  "页面.配置.福利与保障标签.中文标签": "Chinese label",
  "页面.配置.福利与保障标签.全部分类": "All categories",
  "页面.配置.福利与保障标签.关键词": "Keyword",
  "页面.配置.福利与保障标签.关键词说明": "Filter by category, code, or any label language",
  "页面.配置.福利与保障标签.分类.benefit_guarantee": "Benefit & guarantee tags",
  "页面.配置.福利与保障标签.分类.job_requirement": "Job requirement tags",
  "页面.配置.福利与保障标签.分类.platform_status": "Platform / status tags",
  "页面.配置.福利与保障标签.分类.work_mode": "Work mode tags",
  "页面.配置.福利与保障标签.创建时间": "Created at",
  "页面.配置.福利与保障标签.创建时间说明": "Created at, hover for raw",
  "页面.配置.福利与保障标签.字段必填": "This field is required",
  "页面.配置.福利与保障标签.成功删除N个": "Deleted {n} tags",
  "页面.配置.福利与保障标签.成功删除部分失败": "Deleted {ok}, failed {fail}",
  "页面.配置.福利与保障标签.排序": "Order",
  "页面.配置.福利与保障标签.排序说明": "Smaller = higher rank",
  "页面.配置.福利与保障标签.新建按钮": "New tag",
  "页面.配置.福利与保障标签.新建标题": "New tag",
  "页面.配置.福利与保障标签.是否启用": "Active",
  "页面.配置.福利与保障标签.标签ID": "Tag ID",
  "页面.配置.福利与保障标签.标签分类": "Tag category",
  "页面.配置.福利与保障标签.正在删除N个": "Deleting {n} tags...",
  "页面.配置.福利与保障标签.正在更新": "Updating...",
  "页面.配置.福利与保障标签.正在添加": "Adding...",
  "页面.配置.福利与保障标签.确定删除": "Delete this tag? Existing JD relations keep IDs but the tag will no longer appear in lists.",
  "页面.配置.福利与保障标签.编码": "Code",
  "页面.配置.福利与保障标签.编码只读说明": "Cannot be changed after create; JD relations store this code",
  "页面.配置.福利与保障标签.编码说明": "Auto-generated on create; used in APIs and storage; not editable",
  "页面.配置.福利与保障标签.编辑标题": "Edit tag",
  "页面.配置.福利与保障标签.英文标签": "English label",
  "页面.配置.福利与保障标签.页面标题": "Tag lexicon",
  "页面.配置.福利与保障标签.高棉语标签": "Khmer label",
  "页面.配置.销售联系方式.Telegram占位": "Username, @username, or a t.me link",
  "页面.配置.销售联系方式.Telegram标题": "Telegram",
  "页面.配置.销售联系方式.加载失败": "Failed to load sales contacts. Please retry.",
  "页面.配置.销售联系方式.启用": "Enabled",
  "页面.配置.销售联系方式.正在保存": "Saving sales contacts...",
  "页面.配置.销售联系方式.添加联系方式": "Add contact",
  "页面.配置.销售联系方式.电话占位": "For example: +855 12 345 678",
  "页面.配置.销售联系方式.电话标题": "Phone",
  "页面.配置.销售联系方式.类型": "Type",
  "页面.配置.销售联系方式.联系方式": "Contact value",
  "页面.配置.销售联系方式.说明内容": "Used by the Contact Sales entry when an employer reaches the posting limit. Multiple Telegram usernames and phone numbers are supported; only enabled contacts are sent to the app.",
  "页面.配置.销售联系方式.说明标题": "App display rules",
  "页面.配置.销售联系方式.请输入Telegram": "Enter a Telegram username",
  "页面.配置.销售联系方式.请输入电话": "Enter a phone number",
  "页面.配置.销售联系方式.重新加载": "Reload",
  "页面.配置.销售联系方式.页面标题": "Sales Contacts",
  "页面.首页金刚位.保存排序": "Save order",
  "页面.首页金刚位.双页排序": "Reorder Home Shortcuts",
  "页面.首页金刚位.双页排序说明": "Both pages show every enabled item. Drag non-fixed items to reorder; fixed items stay in their assigned slots.",
  "页面.首页金刚位.固定第N位": "Fixed #{position}",
  "页面.首页金刚位.已是最前可调整位置": "Already in the first movable position",
  "页面.首页金刚位.已移到最前": "Moved to front",
  "页面.首页金刚位.拖拽调整顺序": "Drag to reorder",
  "页面.首页金刚位.排序": "Reorder",
  "页面.首页金刚位.排序保存失败": "Failed to save the order. Please retry",
  "页面.首页金刚位.排序保存成功": "Order saved",
  "页面.首页金刚位.排序已保存列表刷新失败": "Order saved, but the list could not refresh. Reload to confirm",
  "页面.首页金刚位.移到最前": "Move to front",
  "页面.首页金刚位.移到最前失败": "Failed to move the item; the previous order was restored",
  "页面.首页金刚位.第N页": "Page {page}",
  "页面.首页金刚位.顺序": "Order",
  "顶栏.个人设置": "Settings",
  "顶栏.帮助": "Docs",
  "顶栏.搜索": "Search",
  "顶栏.用户": "User",
  "顶栏.角色": "Roles",
  "顶栏.语言": "Language",
  "顶栏.退出登录": "Logout",
  "顶栏.通知": "Notifications"
};
